/* eslint-disable max-len */

import PropTypes from 'prop-types';

const defaultColor = '#F3F5FD';

export const UserAddIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="9.31162" cy="7.33333" rx="4.65585" ry="4.58333" fill={iconcolor} />
    <path
      d="M17.6924 9.1665L17.6924 14.6665"
      stroke={iconcolor}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M20.4858 11.9165L14.8988 11.9165"
      stroke={iconcolor}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15.9452 18.6878C16.3831 18.5902 16.6455 18.1344 16.4471 17.732C15.9322 16.6873 15.0924 15.7693 14.0065 15.076C12.6597 14.2161 11.0094 13.75 9.31167 13.75C7.61397 13.75 5.9637 14.2161 4.61681 15.076C3.53091 15.7693 2.69114 16.6873 2.1762 17.732C1.97786 18.1344 2.24026 18.5902 2.67814 18.6878C7.04687 19.6618 11.5765 19.6618 15.9452 18.6878Z"
      fill={iconcolor}
    />
  </svg>
);
UserAddIcon.propTypes = { iconcolor: PropTypes.string };

export const UserProfileIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.2835 14.0011C27.2835 6.66368 21.3362 0.71875 14.0011 0.71875C6.66605 0.71875 0.71875 6.66368 0.71875 14.0011C0.71875 21.3362 6.66605 27.2835 14.0011 27.2835C21.3362 27.2835 27.2835 21.3362 27.2835 14.0011Z"
      fill="#ADCE00"
    />
    <path
      d="M14.0012 1.43523C7.07176 1.43523 1.4376 7.07176 1.4376 13.9988C1.4376 20.9282 7.07176 26.5648 14.0012 26.5648C20.9306 26.5648 26.5671 20.9282 26.5671 13.9988C26.5671 7.07176 20.9306 1.43523 14.0012 1.43523ZM14.0012 28C6.28179 28 0 21.7182 0 13.9988C0 6.27942 6.28179 0 14.0012 0C21.7206 0 28 6.27942 28 13.9988C28 21.7182 21.7206 28 14.0012 28Z"
      fill="#ADCE00"
    />
    <path
      d="M17.6571 9.12638C17.6571 7.10758 16.0202 5.4707 14.0014 5.4707C11.9826 5.4707 10.3457 7.10758 10.3457 9.12638C10.3457 11.1452 11.9826 12.7821 14.0014 12.7821C16.0202 12.7821 17.6571 11.1452 17.6571 9.12638Z"
      fill="#D5E0F9"
    />
    <path
      d="M14.001 6.18676C12.3807 6.18676 11.0618 7.50575 11.0618 9.12601C11.0618 10.7463 12.3807 12.0653 14.001 12.0653C15.6237 12.0653 16.9403 10.7463 16.9403 9.12601C16.9403 7.50575 15.6237 6.18676 14.001 6.18676ZM14.001 13.5005C11.5884 13.5005 9.62891 11.5386 9.62891 9.12601C9.62891 6.71578 11.5884 4.75391 14.001 4.75391C16.4136 4.75391 18.3755 6.71578 18.3755 9.12601C18.3755 11.5386 16.4136 13.5005 14.001 13.5005Z"
      fill="#2D3B77"
    />
    <path d="M8.17969 21.3813L14.0013 14.9121L19.8252 21.3813" fill="#D5E0F9" />
    <path
      d="M9.78761 20.665H18.2139L14.0008 15.9845L9.78761 20.665ZM19.8223 22.0979H8.1792C7.89453 22.0979 7.63832 21.9318 7.52208 21.6732C7.40821 21.4146 7.45566 21.1134 7.64544 20.9022L13.467 14.433C13.6046 14.2812 13.7968 14.1958 14.0008 14.1958C14.2048 14.1958 14.3969 14.2812 14.5322 14.433L20.3561 20.9022C20.5459 21.1134 20.5933 21.4146 20.4795 21.6732C20.3632 21.9318 20.107 22.0979 19.8223 22.0979Z"
      fill="#2D3B77"
    />
  </svg>
);

export const LockIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4142 7.33333V6.47469C15.4142 4.4176 13.7466 2.75 11.6895 2.75V2.75C9.63244 2.75 7.96484 4.4176 7.96484 6.47468V7.33333"
      stroke={iconcolor}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M3.30908 12.3094C3.30908 9.58504 3.30908 8.22288 4.1291 7.35551C4.16764 7.31474 4.20732 7.27507 4.24809 7.23652C5.11545 6.4165 6.47762 6.4165 9.20194 6.4165H14.1773C16.9016 6.4165 18.2638 6.4165 19.1312 7.23652C19.1719 7.27507 19.2116 7.31474 19.2501 7.35551C20.0702 8.22288 20.0702 9.58504 20.0702 12.3094C20.0702 15.9418 20.0702 17.758 18.9768 18.9145C18.9254 18.9689 18.8725 19.0218 18.8182 19.0731C17.6617 20.1665 15.8455 20.1665 12.213 20.1665H11.1662C7.53379 20.1665 5.71758 20.1665 4.56109 19.0731C4.50674 19.0218 4.45383 18.9689 4.40244 18.9145C3.30908 17.758 3.30908 15.9418 3.30908 12.3094Z"
      fill={iconcolor}
    />
  </svg>
);
LockIcon.propTypes = { iconcolor: PropTypes.string };

export const UserIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.014 18.7049C18.5208 18.5993 18.8226 18.0691 18.5708 17.6168C18.0157 16.6198 17.1412 15.7437 16.0224 15.076C14.5816 14.2161 12.8162 13.75 11.0001 13.75C9.18403 13.75 7.41867 14.2161 5.97786 15.076C4.85913 15.7437 3.9846 16.6198 3.42949 17.6168C3.17768 18.0691 3.47948 18.5993 3.98623 18.7049C8.61247 19.6691 13.3878 19.6691 18.014 18.7049Z"
      fill={iconcolor}
    />
    <ellipse cx="10.9998" cy="7.33333" rx="4.58333" ry="4.58333" fill={iconcolor} />
  </svg>
);
UserIcon.propTypes = { iconcolor: PropTypes.string };

export const MailIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.87868 0.87868C0 1.75736 0 3.17157 0 6V10C0 12.8284 0 14.2426 0.87868 15.1213C1.75736 16 3.17157 16 6 16H15C17.8284 16 19.2426 16 20.1213 15.1213C21 14.2426 21 12.8284 21 10V6C21 3.17157 21 1.75736 20.1213 0.87868C19.2426 0 17.8284 0 15 0H6C3.17157 0 1.75736 0 0.87868 0.87868ZM4.04679 3.73415C3.58438 3.43216 2.96471 3.56222 2.66273 4.02463C2.36075 4.48704 2.4908 5.10671 2.95321 5.40869L9.40642 9.62303C10.0709 10.057 10.9291 10.057 11.5936 9.62303L18.0468 5.40869C18.5092 5.10671 18.6393 4.48704 18.3373 4.02463C18.0353 3.56222 17.4156 3.43216 16.9532 3.73415L10.5 7.94849L4.04679 3.73415Z"
      fill={iconcolor}
    />
  </svg>
);
MailIcon.propTypes = { iconcolor: PropTypes.string };

export const LocationIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.625 6.73832C0.625 3.28842 3.50791 0.5 6.99508 0.5C10.4921 0.5 13.375 3.28842 13.375 6.73832C13.375 8.47677 12.7428 10.0907 11.7021 11.4587C10.5541 12.9676 9.13912 14.2823 7.54641 15.3143C7.18188 15.5528 6.85291 15.5708 6.45284 15.3143C4.85105 14.2823 3.43607 12.9676 2.29787 11.4587C1.25649 10.0907 0.625 8.47677 0.625 6.73832ZM4.89567 6.93258C4.89567 8.0883 5.83874 8.99727 6.99508 8.99727C8.15218 8.99727 9.10433 8.0883 9.10433 6.93258C9.10433 5.78586 8.15218 4.83264 6.99508 4.83264C5.83874 4.83264 4.89567 5.78586 4.89567 6.93258Z"
      fill={iconcolor}
    />
  </svg>
);
LocationIcon.propTypes = { iconcolor: PropTypes.string };

// export const ReceptionBellIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="14"
//     height="16"
//     viewBox="0 0 14 16"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M0.625 6.73832C0.625 3.28842 3.50791 0.5 6.99508 0.5C10.4921 0.5 13.375 3.28842 13.375 6.73832C13.375 8.47677 12.7428 10.0907 11.7021 11.4587C10.5541 12.9676 9.13912 14.2823 7.54641 15.3143C7.18188 15.5528 6.85291 15.5708 6.45284 15.3143C4.85105 14.2823 3.43607 12.9676 2.29787 11.4587C1.25649 10.0907 0.625 8.47677 0.625 6.73832ZM4.89567 6.93258C4.89567 8.0883 5.83874 8.99727 6.99508 8.99727C8.15218 8.99727 9.10433 8.0883 9.10433 6.93258C9.10433 5.78586 8.15218 4.83264 6.99508 4.83264C5.83874 4.83264 4.89567 5.78586 4.89567 6.93258Z"
//       fill={iconcolor}
//     />
//   </svg>
// );
// ReceptionBellIcon.propTypes = { iconcolor: PropTypes.string };

// export const ScreenIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="19"
//     height="15"
//     viewBox="0 0 19 15"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M0 2C0 0.895432 0.895431 0 2 0H16.6207C17.7253 0 18.6207 0.895431 18.6207 2V9.82759H0V2Z"
//       fill={iconcolor}
//     />
//     <path
//       d="M0 10.8621H18.6207C18.6207 11.7191 17.926 12.4138 17.069 12.4138H1.55172C0.694732 12.4138 0 11.7191 0 10.8621Z"
//       fill={iconcolor}
//     />
//     <rect x="7.75879" y="10.8621" width="3.10345" height="3.10345" fill={iconcolor} />
//     <rect
//       x="5.68994"
//       y="13.9656"
//       width="7.24138"
//       height="1.03448"
//       rx="0.517241"
//       fill={iconcolor}
//     />
//   </svg>
// );
// ScreenIcon.propTypes = { iconcolor: PropTypes.string };

// export const ToolsIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="18"
//     height="19"
//     viewBox="0 0 18 19"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M0.578355 3.59119C0.172454 3.03785 0.231035 2.27112 0.716286 1.78587C1.20269 1.29946 1.97168 1.2419 2.52508 1.65048L3.39716 2.29436C3.9415 2.69625 4.14079 3.37574 3.96825 3.97662L10.0503 10.0587C10.6949 9.81926 11.4482 9.95932 11.9651 10.4782L16.4085 14.9385C17.1144 15.6471 17.1122 16.7937 16.4037 17.4996C15.6951 18.2055 14.5485 18.2033 13.8426 17.4947L9.39921 13.0344C8.88402 12.5173 8.746 11.7668 8.98451 11.1246L8.98037 11.1287L2.8947 5.04305C2.29478 5.21098 1.61871 5.00944 1.21953 4.46527L0.578355 3.59119Z"
//       fill={iconcolor}
//     />
//     <path
//       d="M9.70383 5.79349L8.41357 7.08373C8.65934 7.29877 9.67311 8.31254 9.98031 8.61975C10.779 8.22038 11.4549 8.61975 11.7007 8.89623C11.9157 8.68119 12.0079 8.58903 12.3151 8.31254C14.4348 9.04983 18.0905 7.88246 17.9983 3.82737C17.9676 3.15153 17.4146 3.24369 17.3839 3.30514C16.7388 3.88882 16.4316 4.3189 16.1551 4.50322C13.8204 5.6706 12.6223 3.52017 13.2981 2.29136C13.4947 1.84898 14.1583 1.12399 14.5269 0.816783C15.2335 0.227973 14.2812 -0.080242 13.2981 0.0180559C10.2261 0.325244 8.84366 3.48946 9.70383 5.79349Z"
//       fill={iconcolor}
//     />
//     <path
//       d="M7.55277 11.016L6.01675 9.51074C4.66507 10.8624 1.43944 14.0574 0.487091 15.0404C-1.0795 17.0679 1.50095 18.8804 3.03689 17.5595L7.79853 12.7978C7.30702 12.2141 7.24558 11.6919 7.55277 11.016Z"
//       fill={iconcolor}
//     />
//   </svg>
// );
// ToolsIcon.propTypes = { iconcolor: PropTypes.string };

// export const ChatIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="22"
//     height="22"
//     viewBox="0 0 22 22"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M11 2.75C15.5563 2.75 19.25 6.44365 19.25 11C19.25 15.5563 15.5563 19.25 11 19.25H6.875C5.82833 19.25 5.30499 19.25 4.87915 19.1208C3.92034 18.83 3.17003 18.0797 2.87918 17.1209C2.75 16.695 2.75 16.1717 2.75 15.125V11C2.75 6.44365 6.44365 2.75 11 2.75ZM14.75 10.0833C14.75 9.53105 14.3023 9.08333 13.75 9.08333H8.25C7.69772 9.08333 7.25 9.53105 7.25 10.0833C7.25 10.6356 7.69772 11.0833 8.25 11.0833H13.75C14.3023 11.0833 14.75 10.6356 14.75 10.0833ZM12 13.75C12 13.1977 11.5523 12.75 11 12.75H8.25C7.69772 12.75 7.25 13.1977 7.25 13.75C7.25 14.3023 7.69772 14.75 8.25 14.75H11C11.5523 14.75 12 14.3023 12 13.75Z"
//       fill={iconcolor}
//     />
//   </svg>
// );
// ChatIcon.propTypes = { iconcolor: PropTypes.string };

export const BellIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.96077 6.39384C6.21967 3.80485 8.39826 1.83325 11.0002 1.83325C13.6021 1.83325 15.7807 3.80484 16.0396 6.39384L16.3023 9.02113C16.4322 10.3205 16.8789 11.5681 17.6033 12.6546L18.3926 13.8386C19.0339 14.8006 19.3546 15.2815 19.2821 15.6792C19.2446 15.8849 19.1436 16.0737 18.9932 16.219C18.7025 16.4999 18.1245 16.4999 16.9684 16.4999H5.03196C3.87585 16.4999 3.29779 16.4999 3.00712 16.219C2.85675 16.0737 2.75571 15.8849 2.71822 15.6792C2.64574 15.2815 2.96639 14.8006 3.60768 13.8386L4.39706 12.6546C5.12139 11.5681 5.56811 10.3205 5.69804 9.02114L5.96077 6.39384Z"
      fill={iconcolor}
    />
    <path
      d="M9.2293 18.9103C9.33375 19.0077 9.56392 19.0939 9.8841 19.1553C10.2043 19.2167 10.5966 19.25 11.0002 19.25C11.4037 19.25 11.796 19.2167 12.1162 19.1553C12.4364 19.0939 12.6666 19.0077 12.771 18.9103"
      stroke={iconcolor}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
BellIcon.propTypes = { iconcolor: PropTypes.string };

export const AgeLimitIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="22" height="22" rx="6" fill={iconcolor} />
    <path
      d="M2.86914 8.4V6.981H5.52014V15H3.93614V8.4H2.86914ZM8.3835 10.754C7.65016 10.3727 7.2835 9.78233 7.2835 8.983C7.2835 8.587 7.3825 8.22767 7.5805 7.905C7.78583 7.575 8.09016 7.31467 8.4935 7.124C8.90416 6.926 9.40283 6.827 9.9895 6.827C10.5762 6.827 11.0712 6.926 11.4745 7.124C11.8852 7.31467 12.1895 7.575 12.3875 7.905C12.5928 8.22767 12.6955 8.587 12.6955 8.983C12.6955 9.38633 12.5965 9.742 12.3985 10.05C12.2005 10.3507 11.9365 10.5853 11.6065 10.754C12.0098 10.93 12.3252 11.1867 12.5525 11.524C12.7798 11.8613 12.8935 12.261 12.8935 12.723C12.8935 13.2217 12.7652 13.658 12.5085 14.032C12.2592 14.3987 11.9145 14.681 11.4745 14.879C11.0345 15.077 10.5395 15.176 9.9895 15.176C9.4395 15.176 8.9445 15.077 8.5045 14.879C8.07183 14.681 7.72716 14.3987 7.4705 14.032C7.22116 13.658 7.0965 13.2217 7.0965 12.723C7.0965 12.261 7.21016 11.8613 7.4375 11.524C7.66483 11.1793 7.98016 10.9227 8.3835 10.754ZM11.1995 9.203C11.1995 8.84367 11.0895 8.565 10.8695 8.367C10.6568 8.169 10.3635 8.07 9.9895 8.07C9.62283 8.07 9.3295 8.169 9.1095 8.367C8.89683 8.565 8.7905 8.84733 8.7905 9.214C8.7905 9.544 8.9005 9.808 9.1205 10.006C9.34783 10.204 9.6375 10.303 9.9895 10.303C10.3415 10.303 10.6312 10.204 10.8585 10.006C11.0858 9.80067 11.1995 9.533 11.1995 9.203ZM9.9895 11.425C9.5715 11.425 9.2305 11.5313 8.9665 11.744C8.70983 11.9567 8.5815 12.261 8.5815 12.657C8.5815 13.0237 8.70616 13.3243 8.9555 13.559C9.21216 13.7863 9.55683 13.9 9.9895 13.9C10.4222 13.9 10.7632 13.7827 11.0125 13.548C11.2618 13.3133 11.3865 13.0163 11.3865 12.657C11.3865 12.2683 11.2582 11.9677 11.0015 11.755C10.7448 11.535 10.4075 11.425 9.9895 11.425Z"
      fill="white"
    />
    <path
      d="M18.7958 11.345H17.0948V13.091H15.9068V11.345H14.2058V10.247H15.9068V8.501H17.0948V10.247H18.7958V11.345Z"
      fill="white"
    />
  </svg>
);
AgeLimitIcon.propTypes = { iconcolor: PropTypes.string };

export const PaperIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.38297 16.5485H12.7196C13.1972 16.5485 13.5932 16.1575 13.5932 15.686C13.5932 15.2145 13.1972 14.835 12.7196 14.835H6.38297C5.90539 14.835 5.50935 15.2145 5.50935 15.686C5.50935 16.1575 5.90539 16.5485 6.38297 16.5485ZM10.3201 9.08496H6.38297C5.90539 9.08496 5.50935 9.47596 5.50935 9.94746C5.50935 10.419 5.90539 10.7985 6.38297 10.7985H10.3201C10.7976 10.7985 11.1937 10.419 11.1937 9.94746C11.1937 9.47596 10.7976 9.08496 10.3201 9.08496ZM18.633 8.07945C18.9068 8.07636 19.205 8.073 19.4758 8.073C19.767 8.073 20 8.303 20 8.5905V17.8365C20 20.6885 17.6587 23 14.7699 23H5.49796C2.46942 23 0 20.5735 0 17.5835V5.1865C0 2.3345 2.35294 0 5.25335 0H11.4735C11.7764 0 12.0093 0.2415 12.0093 0.529V4.232C12.0093 6.3365 13.7682 8.0615 15.8998 8.073C16.3977 8.073 16.8367 8.07664 17.2208 8.07982C17.5197 8.0823 17.7853 8.0845 18.0198 8.0845C18.1856 8.0845 18.4005 8.08208 18.633 8.07945ZM18.9543 6.4007C17.9969 6.40415 16.8682 6.4007 16.0563 6.39265C14.768 6.39265 13.7068 5.345 13.7068 4.0731V1.0417C13.7068 0.546052 14.316 0.299952 14.6643 0.657602C15.2948 1.3048 16.1612 2.19445 17.0236 3.08001C17.8836 3.96313 18.7397 4.84218 19.3539 5.47265C19.694 5.8211 19.4447 6.39955 18.9543 6.4007Z"
      fill={iconcolor}
    />
  </svg>
);
PaperIcon.propTypes = { iconcolor: PropTypes.string };

export const ImageIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.2328 22H15.7661C19.4954 22 22 19.3841 22 15.4916V6.50839C22 2.61592 19.4954 0 15.7672 0H6.2328C2.50459 0 0 2.61592 0 6.50839V15.4916C0 19.3841 2.50459 22 6.2328 22ZM7.14891 9.89992C5.6324 9.89992 4.40017 8.66601 4.40017 7.14992C4.40017 5.63382 5.6324 4.39992 7.14891 4.39992C8.66431 4.39992 9.89765 5.63382 9.89765 7.14992C9.89765 8.66601 8.66431 9.89992 7.14891 9.89992ZM19.6027 14.2273C19.971 15.1717 19.7797 16.3069 19.3859 17.2423C18.9191 18.3548 18.0254 19.1971 16.8993 19.5649C16.3993 19.7284 15.875 19.7999 15.3518 19.7999H6.08131C5.1588 19.7999 4.34247 19.5785 3.67326 19.1665C3.25403 18.9076 3.17992 18.3105 3.49075 17.9234C4.01063 17.2764 4.52388 16.627 5.04155 15.972C6.02822 14.7188 6.69301 14.3555 7.4319 14.6745C7.73167 14.8062 8.03253 15.0037 8.34225 15.2126C9.16743 15.7734 10.3145 16.5442 11.8255 15.7075C12.8595 15.1284 13.4592 14.1351 13.9814 13.27L13.9902 13.2555C14.0272 13.1948 14.0639 13.1341 14.1004 13.0736C14.276 12.7832 14.4491 12.4967 14.645 12.2327C14.8906 11.9024 15.8009 10.8694 16.9801 11.605C17.7311 12.0681 18.3627 12.6947 19.0386 13.3656C19.2963 13.6222 19.4799 13.9139 19.6027 14.2273Z"
      fill={iconcolor}
    />
  </svg>
);
ImageIcon.propTypes = { iconcolor: PropTypes.string };

export const HardFolderIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 -0.00012207C4.34315 -0.00012207 3 1.34302 3 2.99988V3.00056C1.92115 3.00526 1.32954 3.04249 0.88886 3.33694C0.670479 3.48286 0.482978 3.67036 0.337061 3.88874C0 4.39318 0 5.09542 0 6.49988V15.9999C0 17.8855 0 18.8283 0.585786 19.4141C1.17157 19.9999 2.11438 19.9999 4 19.9999H12C13.8856 19.9999 14.8284 19.9999 15.4142 19.4141C16 18.8283 16 17.8855 16 15.9999V6.49988C16 5.09542 16 4.39318 15.6629 3.88874C15.517 3.67036 15.3295 3.48286 15.1111 3.33694C14.6705 3.04249 14.0789 3.00526 13 3.00056V2.99988C13 1.34302 11.6569 -0.00012207 10 -0.00012207H6ZM6 2.99988C6 2.44759 6.44772 1.99988 7 1.99988H9C9.55228 1.99988 10 2.44759 10 2.99988C10 3.55216 9.55228 3.99988 9 3.99988H7C6.44772 3.99988 6 3.55216 6 2.99988ZM5 8.99988C4.44772 8.99988 4 9.44759 4 9.99988C4 10.5522 4.44772 10.9999 5 10.9999H11C11.5523 10.9999 12 10.5522 12 9.99988C12 9.44759 11.5523 8.99988 11 8.99988H5ZM5 12.9999C4.44772 12.9999 4 13.4476 4 13.9999C4 14.5522 4.44772 14.9999 5 14.9999H9C9.55228 14.9999 10 14.5522 10 13.9999C10 13.4476 9.55228 12.9999 9 12.9999H5Z"
      fill={iconcolor}
    />
  </svg>
);
HardFolderIcon.propTypes = { iconcolor: PropTypes.string };

export const HandBagIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6667 1.49988H9.33333C9.05719 1.49988 8.83333 1.72374 8.83333 1.99988V2.75853H13.1667V1.99988C13.1667 1.72374 12.9428 1.49988 12.6667 1.49988ZM7.33333 1.99988V2.75853H1.5C0.671573 2.75853 0 3.43011 0 4.25854V12.293C0 13.1214 0.671573 13.793 1.5 13.793H20.5C21.3284 13.793 22 13.1214 22 12.293V4.25853C22 3.43011 21.3284 2.75853 20.5 2.75853H14.6667V1.99988C14.6667 0.895309 13.7712 -0.00012207 12.6667 -0.00012207H9.33333C8.22876 -0.00012207 7.33333 0.895308 7.33333 1.99988ZM20.7776 15.1723H1.22205V18.9999C1.22205 19.5522 1.66977 19.9999 2.22205 19.9999H19.7776C20.3299 19.9999 20.7776 19.5522 20.7776 18.9999V15.1723Z"
      fill={iconcolor}
    />
    <rect
      x="9.125"
      y="11.9137"
      width="3.75"
      height="5.13793"
      rx="1"
      fill={iconcolor}
      stroke="white"
    />
  </svg>
);
HandBagIcon.propTypes = { iconcolor: PropTypes.string };

export const WalletIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="15"
    height="13.5"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7502 11.611H14.7002"
      stroke={iconcolor}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.87868 0.878558C0 1.75724 0 3.17145 0 5.99988V12.9999C0 15.8283 0 17.2425 0.87868 18.1212C1.75736 18.9999 3.17157 18.9999 6 18.9999H16.7778C17.9153 18.9999 18.4841 18.9999 18.9436 18.8476C19.8435 18.5494 20.5495 17.8434 20.8477 16.9435C21 16.484 21 15.9152 21 14.7777H14.7167C12.9678 14.7777 11.55 13.3599 11.55 11.611C11.55 9.86209 12.9678 8.44432 14.7167 8.44432H21V5.99988C21 3.17145 21 1.75724 20.1213 0.878558C19.2426 -0.00012207 17.8284 -0.00012207 15 -0.00012207H6C3.17157 -0.00012207 1.75736 -0.00012207 0.87868 0.878558ZM5.25 4.27766C4.69772 4.27766 4.25 4.72537 4.25 5.27766C4.25 5.82994 4.69772 6.27766 5.25 6.27766H8.4C8.95229 6.27766 9.4 5.82994 9.4 5.27766C9.4 4.72537 8.95229 4.27766 8.4 4.27766H5.25Z"
      fill={iconcolor}
    />
  </svg>
);
WalletIcon.propTypes = { iconcolor: PropTypes.string };

export const SignOutIcon = ({ iconcolor = '#A9AFCA' }) => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 5C0 2.23857 2.23858 0 5 0H13C15.7614 0 18 2.23858 18 5V11.7143C18 14.4757 15.7614 16.7143 13 16.7143H5C2.23858 16.7143 0 14.4757 0 11.7143V5ZM13.3833 8.07533L11.8785 6.57056C11.8415 6.5335 11.7975 6.50411 11.7491 6.48406C11.7007 6.464 11.6488 6.45368 11.5964 6.45368C11.544 6.45368 11.4921 6.464 11.4437 6.48406C11.3953 6.50411 11.3513 6.5335 11.3142 6.57056C11.2394 6.64539 11.1973 6.74688 11.1973 6.8527C11.1973 6.95853 11.2394 7.06002 11.3142 7.13485L12.1378 7.95847H7.78096C7.67513 7.95847 7.57364 8.0005 7.49881 8.07533C7.42398 8.15016 7.38194 8.25165 7.38194 8.35748C7.38194 8.46331 7.42398 8.5648 7.49881 8.63963C7.57364 8.71446 7.67513 8.75649 7.78096 8.75649H12.1378L11.3142 9.58011C11.2394 9.65494 11.1973 9.75644 11.1973 9.86226C11.1974 9.96809 11.2394 10.0696 11.3142 10.1444C11.3891 10.2192 11.4905 10.2613 11.5964 10.2613C11.7022 10.2613 11.8037 10.2192 11.8785 10.1444L13.3833 8.63962C13.4581 8.56479 13.5002 8.4633 13.5002 8.35747C13.5002 8.25165 13.4581 8.15016 13.3833 8.07533ZM10.1587 10.7351C10.2336 10.6603 10.3351 10.6182 10.4409 10.6182C10.5467 10.6182 10.6482 10.6603 10.723 10.7351C10.7979 10.8099 10.8399 10.9114 10.8399 11.0172V11.5493C10.8399 11.6366 10.8227 11.7231 10.7893 11.8038C10.7559 11.8844 10.7069 11.9578 10.6451 12.0195C10.5834 12.0813 10.5101 12.1302 10.4294 12.1637C10.3487 12.1971 10.2622 12.2143 10.1749 12.2143H6.45074C6.27436 12.2143 6.10521 12.1442 5.9805 12.0195C5.85578 11.8948 5.78571 11.7256 5.78571 11.5493V5.16502C5.78571 4.98865 5.85578 4.8195 5.9805 4.69478C6.10521 4.57007 6.27436 4.5 6.45074 4.5H10.1749C10.2622 4.5 10.3487 4.5172 10.4294 4.55062C10.5101 4.58404 10.5834 4.63303 10.6451 4.69478C10.7069 4.75653 10.7559 4.82985 10.7893 4.91053C10.8227 4.99122 10.8399 5.07769 10.8399 5.16502V5.69704C10.8399 5.80287 10.7979 5.90436 10.723 5.97919C10.6482 6.05402 10.5467 6.09606 10.4409 6.09606C10.3351 6.09606 10.2336 6.05402 10.1587 5.97919C10.0839 5.90436 10.0419 5.80287 10.0419 5.69704V5.29803H6.58374V11.4163H10.0419V11.0172C10.0419 10.9114 10.0839 10.8099 10.1587 10.7351Z"
      fill={iconcolor}
    />
  </svg>
);
SignOutIcon.propTypes = { iconcolor: PropTypes.string };

export const ViewAltIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="3" stroke={iconcolor} strokeWidth="2" />
    <path
      d="M21 12C21 12 20 4 12 4C4 4 3 12 3 12"
      stroke={iconcolor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
ViewAltIcon.propTypes = { iconcolor: PropTypes.string };

// export const ViewAltCrossedIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <circle cx="12" cy="12" r="3" stroke={iconcolor} strokeWidth="2" />
//     <path
//       d="M21 12C21 12 20 4 12 4C4 4 3 12 3 12"
//       stroke={iconcolor}
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );
// ViewAltCrossedIcon.propTypes = { iconcolor: PropTypes.string };

export const CheckmarkCircleIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7C0 3.1367 3.136 0 7 0C10.871 0 14 3.1367 14 7C14 10.8647 10.871 14 7 14C3.136 14 0 10.8647 0 7ZM5.805 9.48168C5.93864 9.6101 6.11202 9.67342 6.28539 9.67166C6.45877 9.67078 6.63124 9.6057 6.76308 9.47552L10.2604 6.02768C10.5231 5.76821 10.5204 5.3513 10.2549 5.09535C9.98857 4.8394 9.55964 4.84116 9.29687 5.10063L6.27546 8.07879L5.03836 6.88964C4.77198 6.63369 4.34396 6.63633 4.08028 6.8958C3.81751 7.15526 3.82022 7.57217 4.0866 7.82812L5.805 9.48168Z"
      fill={iconcolor}
    />
  </svg>
);
CheckmarkCircleIcon.propTypes = { iconcolor: PropTypes.string };

export const ExclamationCircleReverseIcon = ({ iconcolor = '#E84427' }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 5L9 4.2" stroke={iconcolor} strokeWidth="1.5" strokeLinecap="square" />
    <path d="M9 9L9 13.8" stroke={iconcolor} strokeWidth="1.5" strokeLinecap="square" />
    <path
      d="M10.3892 16.8785C11.4238 16.696 12.4124 16.3116 13.2984 15.7471C14.1844 15.1827 14.9506 14.4492 15.5532 13.5886C16.1558 12.728 16.583 11.7572 16.8104 10.7315C17.0378 9.70584 17.0609 8.64543 16.8785 7.61081C16.696 6.5762 16.3116 5.58765 15.7471 4.7016C15.1827 3.81556 14.4492 3.04937 13.5886 2.44678C12.728 1.8442 11.7572 1.41702 10.7315 1.18963C9.70584 0.962246 8.64543 0.939108 7.61081 1.12154C6.5762 1.30397 5.58765 1.6884 4.7016 2.25287C3.81556 2.81734 3.04937 3.55081 2.44678 4.41139C1.8442 5.27197 1.41702 6.24281 1.18963 7.26848C0.962246 8.29416 0.939108 9.35457 1.12154 10.3892C1.30397 11.4238 1.6884 12.4124 2.25287 13.2984C2.81734 14.1844 3.55081 14.9506 4.41139 15.5532C5.27197 16.1558 6.24281 16.583 7.26849 16.8104C8.29416 17.0378 9.35457 17.0609 10.3892 16.8785L10.3892 16.8785Z"
      stroke={iconcolor}
      strokeWidth="1.5"
    />
  </svg>
);
ExclamationCircleReverseIcon.propTypes = { iconcolor: PropTypes.string };

export const ExclamationCircleIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="13"
    height="13"
    viewBox="1.33 1.33 13.33 13.33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33337 7.99955C1.33337 4.32022 4.32004 1.33289 8.00004 1.33289C11.6867 1.33289 14.6667 4.32022 14.6667 7.99955C14.6667 11.6802 11.6867 14.6662 8.00004 14.6662C4.32004 14.6662 1.33337 11.6802 1.33337 7.99955ZM7.41337 5.4729C7.41337 5.15357 7.68004 4.88623 8.00004 4.88623C8.32004 4.88623 8.58004 5.15357 8.58004 5.4729V8.41957C8.58004 8.74023 8.32004 8.99957 8.00004 8.99957C7.68004 8.99957 7.41337 8.74023 7.41337 8.41957V5.4729ZM8.00671 11.1202C7.68004 11.1202 7.42004 10.8535 7.42004 10.5335C7.42004 10.2135 7.68004 9.95354 8.00004 9.95354C8.32671 9.95354 8.58671 10.2135 8.58671 10.5335C8.58671 10.8535 8.32671 11.1202 8.00671 11.1202Z"
      fill={iconcolor}
    />
  </svg>
);
ExclamationCircleIcon.propTypes = { iconcolor: PropTypes.string };

export const MinusOutlinedIcon = () => (
  <svg
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="minus"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" />
  </svg>
);

export const PlusOutlinedIcon = () => (
  <svg
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="plus"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" />
    <path d="M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" />
  </svg>
);

export const CheckmarkIcon = ({ className = '' }) => (
  <svg
    viewBox="0 0 13 10"
    className={`${className} h-[10px] w-[13px]`}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M4.13132 7.88963L1.57517 5.31046C1.28529 5.01797 0.812789 5.01714 0.52188 5.3086C0.233196 5.59783 0.232369 6.06593 0.520029 6.35618L4.13132 10L12.4835 1.57259C12.7695 1.28402 12.7695 0.818885 12.4835 0.530316C12.194 0.238162 11.7218 0.238051 11.4321 0.530068L4.13132 7.88963Z"
    />
  </svg>
);
CheckmarkIcon.propTypes = { className: PropTypes.string };

export const BackArrowIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9506 11H12.4142L15.7071 7.70711L14.2929 6.29289L9.29289 11.2929L8.58579 12L9.29289 12.7071L14.2929 17.7071L15.7071 16.2929L12.4142 13H21.9506C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.1853 2 21.4489 5.94668 21.9506 11Z"
      fill={iconcolor}
    />
  </svg>
);
BackArrowIcon.propTypes = { iconcolor: PropTypes.string };

export const SearchIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2498 8.70832C14.2498 11.7689 11.7687 14.25 8.70817 14.25C5.64759 14.25 3.1665 11.7689 3.1665 8.70832C3.1665 5.64775 5.64759 3.16666 8.70817 3.16666C11.7687 3.16666 14.2498 5.64775 14.2498 8.70832Z"
      fill={iconcolor}
    />
    <path
      d="M15.8333 15.8333L14.25 14.25"
      stroke={iconcolor}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
SearchIcon.propTypes = { iconcolor: PropTypes.string };

export const CloseIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6C0 2.6886 2.688 0 6 0C9.318 0 12 2.6886 12 6C12 9.3126 9.318 12 6 12C2.688 12 0 9.3126 0 6ZM7.98623 8.05003C8.22886 7.81363 8.22886 7.42235 7.98623 7.18596L6.85671 6.08467L7.98623 4.98502C8.22886 4.74862 8.22886 4.3655 7.98623 4.12013C7.74359 3.88374 7.34198 3.88374 7.09934 4.12013L5.96982 5.22142L4.8403 4.12013C4.59767 3.88374 4.20443 3.88374 3.95342 4.12013C3.71078 4.3655 3.71078 4.74862 3.95342 4.98502L5.08294 6.08467L3.95342 7.18596C3.71078 7.42235 3.71078 7.81363 3.95342 8.05003C4.07892 8.1723 4.23789 8.22855 4.39686 8.22855C4.5642 8.22855 4.72317 8.1723 4.8403 8.05003L5.96982 6.94956L7.09934 8.05003C7.22485 8.1723 7.38382 8.22855 7.54278 8.22855C7.70175 8.22855 7.86909 8.1723 7.98623 8.05003Z"
      fill={iconcolor}
    />
  </svg>
);
CloseIcon.propTypes = { iconcolor: PropTypes.string };

export const StarBoxIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="15"
    height="13.5"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9993 2.73676L13 4.52163V7.47969V9.2639C13 10.7727 11.7923 12 10.3077 12H2.69295C1.20835 12 0 10.7727 0 9.2639V7.47969V4.5791L0.0013 2.73676C0.0013 1.22801 1.209 0 2.6936 0H10.3064C11.791 0 12.9993 1.22801 12.9993 2.73676ZM7.9638 6.43203L8.73015 5.67369C8.8634 5.5429 8.90955 5.35001 8.8517 5.17166C8.7945 4.9933 8.645 4.86647 8.4643 4.84071L7.40545 4.68349L6.9316 3.70848C6.85035 3.5407 6.68525 3.43633 6.5013 3.43567H6.5C6.3167 3.43567 6.1516 3.54004 6.06905 3.70782L5.5952 4.68349L4.5383 4.84005C4.35565 4.86647 4.20615 4.9933 4.1483 5.17166C4.0911 5.35001 4.13725 5.5429 4.26985 5.67369L5.0362 6.43203L4.8555 7.50415C4.8243 7.68911 4.89775 7.87275 5.04725 7.98306C5.13175 8.0445 5.2299 8.0762 5.32935 8.0762C5.4054 8.0762 5.4821 8.05705 5.5523 8.01939L6.5 7.51339L7.44575 8.01807C7.60955 8.10725 7.8039 8.09338 7.95275 7.9824C8.1029 7.87275 8.17635 7.68911 8.14515 7.50415L7.9638 6.43203Z"
      fill={iconcolor}
    />
  </svg>
);
StarBoxIcon.propTypes = { iconcolor: PropTypes.string };

export const FireIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="9"
    height="12"
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 4.01752C2.25 3.31546 1.3025 3.12938 1.05112 3.78627C0.443055 5.37526 0 6.79673 0 7.56525C0 10.0145 2.01472 12 4.5 12C6.98528 12 9 10.0145 9 7.56525C9 6.73958 8.4886 5.16024 7.8106 3.4292C6.93232 1.18681 6.49318 0.0656238 5.95109 0.00523378C5.77764 -0.01409 5.58841 0.0206522 5.43365 0.100235C4.95 0.348947 4.95 1.5718 4.95 4.01752C4.95 4.75229 4.34558 5.34794 3.6 5.34794C2.85442 5.34794 2.25 4.75229 2.25 4.01752Z"
      fill={iconcolor}
    />
  </svg>
);
FireIcon.propTypes = { iconcolor: PropTypes.string };

export const FilterIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.6583 4.78392C6.6583 6.18392 5.50414 7.31866 4.07915 7.31866C2.65499 7.31866 1.5 6.18392 1.5 4.78392C1.5 3.38474 2.65499 2.25 4.07915 2.25C5.50414 2.25 6.6583 3.38474 6.6583 4.78392ZM15.37 3.67375C15.9933 3.67375 16.5 4.17153 16.5 4.78392C16.5 5.39714 15.9933 5.89492 15.37 5.89492H10.4384C9.81421 5.89492 9.30754 5.39714 9.30754 4.78392C9.30754 4.17153 9.81421 3.67375 10.4384 3.67375H15.37ZM2.63083 11.9684H7.56247C8.18663 11.9684 8.69329 12.4662 8.69329 13.0794C8.69329 13.6918 8.18663 14.1904 7.56247 14.1904H2.63083C2.00666 14.1904 1.5 13.6918 1.5 13.0794C1.5 12.4662 2.00666 11.9684 2.63083 11.9684ZM13.9208 15.5833C15.3458 15.5833 16.5 14.4486 16.5 13.0494C16.5 11.6494 15.3458 10.5147 13.9208 10.5147C12.4967 10.5147 11.3417 11.6494 11.3417 13.0494C11.3417 14.4486 12.4967 15.5833 13.9208 15.5833Z"
      fill="white"
    />
  </svg>
);

export const CalendarIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 5.10469C0 4.41927 0 4.07655 0.0831294 3.7973C0.275808 3.15004 0.782119 2.64373 1.42938 2.45105C1.70863 2.36792 2.05135 2.36792 2.73677 2.36792L2.75 1Q2.75 0.5 3.25 0.5Q3.75 0.5 3.75 1 L3.75 2.36792H9.25L9.25 1Q9.25 0.5 9.75 0.5Q10.25 0.5 10.25 1L10.25 2.36792H10.2632C10.9487 2.36792 11.2914 2.36792 11.5706 2.45105C12.2179 2.64373 12.7242 3.15004 12.9169 3.7973C13 4.07655 13 4.41927 13 5.10469C13 5.27605 13 5.36173 12.9792 5.43154C12.931 5.59335 12.8045 5.71993 12.6427 5.7681C12.5728 5.78888 12.4872 5.78888 12.3158 5.78888H0.684192C0.512837 5.78888 0.427159 5.78888 0.357345 5.7681C0.19553 5.71993 0.068952 5.59335 0.0207823 5.43154C0 5.36173 0 5.27605 0 5.10469Z"
      fill={iconcolor}
    />
    <path
      d="M0 10C0 11.8856 0 12.8284 0.585786 13.4142C1.17157 14 2.11438 14 4 14H9C10.8856 14 11.8284 14 12.4142 13.4142C13 12.8284 13 11.8856 13 10V8.15807C13 7.68667 13 7.45096 12.8536 7.30452C12.7071 7.15807 12.4714 7.15807 12 7.15807H1C0.528595 7.15807 0.292893 7.15807 0.146447 7.30452C0 7.45096 0 7.68667 0 8.15807V10Z"
      fill={iconcolor}
    />
  </svg>
);
CalendarIcon.propTypes = { iconcolor: PropTypes.string };

export const ClockIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM6.5 2.33333C6.5 2.05719 6.27614 1.83333 6 1.83333C5.72386 1.83333 5.5 2.05719 5.5 2.33333V6.08333C5.5 6.49755 5.83579 6.83333 6.25 6.83333H8C8.27614 6.83333 8.5 6.60948 8.5 6.33333C8.5 6.05719 8.27614 5.83333 8 5.83333H6.5V2.33333Z"
      fill={iconcolor}
    />
  </svg>
);
ClockIcon.propTypes = { iconcolor: PropTypes.string };

export const DuplicateIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0.999999C0 0.447714 0.447715 0 1 0H10.2376C10.7899 0 11.2376 0.447715 11.2376 1V8.29949C11.2376 8.85177 10.7899 9.29949 10.2376 9.29949H1C0.447716 9.29949 0 8.85177 0 8.29949V0.999999Z"
      fill={iconcolor}
    />
    <path
      d="M1.5293 2.44647C1.5293 1.89419 1.97701 1.44647 2.5293 1.44647H11.7669C12.3192 1.44647 12.7669 1.89419 12.7669 2.44647V9.43117C12.7669 9.98346 12.3192 10.4312 11.7669 10.4312H2.5293C1.97701 10.4312 1.5293 9.98346 1.5293 9.43117V2.44647Z"
      fill="white"
    />
    <path
      d="M2.76221 3.92359C2.76221 3.3713 3.20992 2.92358 3.76221 2.92358H12.9999C13.5521 2.92358 13.9999 3.3713 13.9999 3.92358V11.0005C13.9999 11.5528 13.5521 12.0005 12.9999 12.0005H3.76221C3.20992 12.0005 2.76221 11.5528 2.76221 11.0005V3.92359Z"
      fill={iconcolor}
    />
  </svg>
);
DuplicateIcon.propTypes = { iconcolor: PropTypes.string };

// export const PieChartIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="13.5"
//     height="13.5"
//     viewBox="0 0 12 12"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM6.08288 1.39923C5.99994 1.47373 5.99994 1.59376 5.99994 1.83381V5.7118C5.99994 5.85268 5.99994 5.92312 5.96645 5.98114C5.93295 6.03915 5.87195 6.07437 5.74994 6.14481L2.3915 8.08381C2.18361 8.20383 2.07967 8.26384 2.05662 8.37292C2.03357 8.48201 2.09944 8.57221 2.23119 8.75262C2.61354 9.27621 3.10197 9.71593 3.66661 10.0419C4.37603 10.4515 5.18077 10.6671 5.99994 10.6671C6.81911 10.6671 7.62385 10.4515 8.33327 10.0419C9.0427 9.63234 9.63181 9.04323 10.0414 8.33381C10.451 7.62438 10.6666 6.81964 10.6666 6.00047C10.6666 5.1813 10.451 4.37656 10.0414 3.66714C9.63181 2.95772 9.0427 2.36861 8.33327 1.95902C7.76863 1.63303 7.14362 1.4299 6.499 1.36057C6.27688 1.33668 6.16583 1.32473 6.08288 1.39923Z"
//       fill={iconcolor}
//     />
//   </svg>
// );
// PieChartIcon.propTypes = { iconcolor: PropTypes.string };

export const ShieldCheckmarkIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1603 2.97919L8.73092 0.65233C7.94483 0.315434 7.05501 0.315434 6.26892 0.65233L0.839586 2.97919C0.456582 3.14333 0.208252 3.51993 0.208252 3.93663V9.4084C0.208252 11.4268 1.18304 13.321 2.82551 14.4942L6.28901 16.9682C7.01338 17.4856 7.98646 17.4856 8.71083 16.9682L12.1743 14.4942C13.8168 13.321 14.7916 11.4268 14.7916 9.4084V3.93663C14.7916 3.51993 14.5433 3.14333 14.1603 2.97919ZM11.4058 6.9997C11.7508 6.56843 11.6809 5.93914 11.2496 5.59413C10.8184 5.24912 10.1891 5.31904 9.84405 5.75031L6.37533 10.0862L5.08203 8.79289C4.6915 8.40237 4.05834 8.40237 3.66781 8.79289C3.27729 9.18342 3.27729 9.81658 3.66781 10.2071L5.35613 11.8954C5.9883 12.5276 7.02961 12.4699 7.5881 11.7718L11.4058 6.9997Z"
      fill={iconcolor}
    />
  </svg>
);
ShieldCheckmarkIcon.propTypes = { iconcolor: PropTypes.string };

export const UploadIcon = ({ iconcolor = defaultColor, dimensions = 18 }) => (
  <svg
    width={dimensions}
    height={dimensions}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 3.75L8.46967 3.21967L9 2.68934L9.53033 3.21967L9 3.75ZM9.75 10.5C9.75 10.9142 9.41421 11.25 9 11.25C8.58579 11.25 8.25 10.9142 8.25 10.5L9.75 10.5ZM4.71967 6.96967L8.46967 3.21967L9.53033 4.28033L5.78033 8.03033L4.71967 6.96967ZM9.53033 3.21967L13.2803 6.96967L12.2197 8.03033L8.46967 4.28033L9.53033 3.21967ZM9.75 3.75L9.75 10.5L8.25 10.5L8.25 3.75L9.75 3.75Z"
      fill={iconcolor}
    />
    <path
      d="M5.25 14.25L5.25 15H5.25V14.25ZM12.75 14.25V15V14.25ZM5.25 15L12.75 15V13.5L5.25 13.5V15ZM4.5 12.75V12H3V12.75H4.5ZM15 12.75V12H13.5V12.75H15ZM12.75 15C13.9926 15 15 13.9926 15 12.75H13.5C13.5 13.1642 13.1642 13.5 12.75 13.5V15ZM5.25 13.5C4.83579 13.5 4.5 13.1642 4.5 12.75H3C3 13.9926 4.00736 15 5.25 15L5.25 13.5Z"
      fill={iconcolor}
    />
  </svg>
);
UploadIcon.propTypes = { iconcolor: PropTypes.string, dimensions: PropTypes.number };

// export const FlagIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="12"
//     height="14"
//     viewBox="0 0 12 14"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M1 1.5V7.85714H4.54089C4.84518 7.85714 4.99733 7.85714 5.11901 7.93329C5.2407 8.00944 5.30722 8.14628 5.44025 8.41995L5.72641 9.00862C5.85945 9.28229 5.92597 9.41913 6.04765 9.49528C6.16934 9.57143 6.32149 9.57143 6.62578 9.57143H10.5C10.7357 9.57143 10.8536 9.57143 10.9268 9.49821C11 9.42498 11 9.30713 11 9.07143V3.21429C11 2.97858 11 2.86073 10.9268 2.78751C10.8536 2.71429 10.7357 2.71429 10.5 2.71429H6.62578C6.32149 2.71429 6.16934 2.71429 6.04765 2.63814C5.92597 2.56199 5.85945 2.42515 5.72641 2.15148L5.44025 1.56281C5.30722 1.28914 5.2407 1.1523 5.11901 1.07615C4.99733 1 4.84518 1 4.54089 1H1.5C1.2643 1 1.14645 1 1.07322 1.07322C1 1.14645 1 1.2643 1 1.5Z"
//       fill={iconcolor}
//     />
//     <path
//       d="M1 7.85714V1.5C1 1.2643 1 1.14645 1.07322 1.07322C1.14645 1 1.2643 1 1.5 1H4.54089C4.84518 1 4.99733 1 5.11901 1.07615C5.2407 1.1523 5.30722 1.28914 5.44025 1.56281L5.72641 2.15148C5.85945 2.42515 5.92597 2.56199 6.04765 2.63814C6.16934 2.71429 6.32149 2.71429 6.62578 2.71429H10.5C10.7357 2.71429 10.8536 2.71429 10.9268 2.78751C11 2.86073 11 2.97858 11 3.21429V9.07143C11 9.30713 11 9.42498 10.9268 9.49821C10.8536 9.57143 10.7357 9.57143 10.5 9.57143H6.62578C6.32149 9.57143 6.16934 9.57143 6.04765 9.49528C5.92597 9.41913 5.85945 9.28229 5.72641 9.00862L5.44025 8.41995C5.30722 8.14628 5.2407 8.00944 5.11901 7.93329C4.99733 7.85714 4.84518 7.85714 4.54089 7.85714H1ZM1 7.85714V13"
//       stroke={iconcolor}
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//   </svg>
// );
// FlagIcon.propTypes = { iconcolor: PropTypes.string };

// export const BoxIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="19"
//     height="19"
//     viewBox="0 0 19 19"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M3.16675 7.99017C3.16675 7.17267 3.16675 6.76392 3.31899 6.39637C3.47123 6.02883 3.76026 5.7398 4.33832 5.16174L4.37018 5.12989C4.94824 4.55183 5.23727 4.26279 5.60481 4.11055C5.97235 3.95831 6.3811 3.95831 7.1986 3.95831H11.8016C12.6191 3.95831 13.0278 3.95831 13.3954 4.11055C13.7629 4.26279 14.0519 4.55183 14.63 5.12989L14.6618 5.16174L14.6618 5.16175C15.2399 5.7398 15.5289 6.02883 15.6812 6.39637C15.8334 6.76392 15.8334 7.17267 15.8334 7.99017V8.20831H3.16675V7.99017ZM12.1388 9.20831H15.8334V11.8333C15.8334 13.7189 15.8334 14.6617 15.2476 15.2475C14.6618 15.8333 13.719 15.8333 11.8334 15.8333H7.16675C5.28113 15.8333 4.33832 15.8333 3.75253 15.2475C3.16675 14.6617 3.16675 13.7189 3.16675 11.8333V9.20831H6.86106L6.86106 12.4028C6.86106 13.0082 6.86106 13.311 6.93937 13.4737C7.11416 13.8369 7.53397 14.0108 7.91441 13.8776C8.08484 13.8179 8.29891 13.6038 8.72704 13.1757C8.92533 12.9774 9.02448 12.8782 9.1299 12.8225C9.36142 12.7001 9.63849 12.7001 9.87001 12.8225C9.97542 12.8782 10.0746 12.9774 10.2729 13.1757C10.701 13.6038 10.9151 13.8179 11.0855 13.8776C11.4659 14.0108 11.8857 13.8369 12.0605 13.4737C12.1388 13.311 12.1388 13.0082 12.1388 12.4028V9.20831Z"
//       fill={iconcolor}
//     />
//   </svg>
// );
// BoxIcon.propTypes = { iconcolor: PropTypes.string };

export const DownloadIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0001 12.8333L10.293 13.5404L11.0001 14.2475L11.7072 13.5404L11.0001 12.8333ZM12.0001 4.58325C12.0001 4.03097 11.5524 3.58325 11.0001 3.58325C10.4478 3.58325 10.0001 4.03097 10.0001 4.58325L12.0001 4.58325ZM5.70964 8.95703L10.293 13.5404L11.7072 12.1261L7.12386 7.54281L5.70964 8.95703ZM11.7072 13.5404L16.2905 8.95703L14.8763 7.54281L10.293 12.1261L11.7072 13.5404ZM12.0001 12.8333L12.0001 4.58325L10.0001 4.58325L10.0001 12.8333L12.0001 12.8333Z"
      fill={iconcolor}
    />
    <path
      d="M4.58325 14.6667L4.58325 15.5834C4.58325 16.5959 5.40406 17.4167 6.41659 17.4167L15.5833 17.4167C16.5958 17.4167 17.4166 16.5959 17.4166 15.5834V14.6667"
      stroke={iconcolor}
      strokeWidth="2"
    />
  </svg>
);
DownloadIcon.propTypes = { iconcolor: PropTypes.string };

export const CaretIcon = () => (
  <svg
    width="7"
    height="11"
    viewBox="0 0 7 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L6 5.5L1 10"
      stroke="#130F26"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 8L12 16" stroke={iconcolor} strokeWidth="1.2" strokeLinecap="round" />
    <path d="M16 12L8 12" stroke={iconcolor} strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);
AddIcon.propTypes = { iconcolor: PropTypes.string };

// export const InfoCircleIcon = () => (
//   <svg
//     width="17"
//     height="17"
//     viewBox="0 0 17 17"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M0.583496 8.49992C0.583496 12.8722 4.12791 16.4166 8.50016 16.4166C12.8724 16.4166 16.4168 12.8722 16.4168 8.49992C16.4168 4.12766 12.8724 0.583252 8.50016 0.583252C4.12791 0.583252 0.583496 4.12766 0.583496 8.49992ZM9.50016 7.49992L9.50016 8.49992V13.2499V14.2499H7.50016V13.2499L7.50016 8.49992V7.49992H9.50016ZM7.50016 4.54158V5.54158H9.50016V4.54158V3.74992V2.74992H7.50016V3.74992V4.54158Z"
//       fill="white"
//     />
//   </svg>
// );

export const StarBoxQuestionMarkIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="30"
    height="29"
    viewBox="0 0 30 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.29525 5.71218C2.41657 6.59086 2.41657 8.00507 2.41657 10.8335V12.0835L2.4165 13.7167L2.41657 15.3202V16.9168V18.1668C2.41657 20.9953 2.41657 22.4095 3.29525 23.2881C4.17393 24.1668 5.58814 24.1668 8.41656 24.1668H20.5832C23.4117 24.1668 24.8259 24.1668 25.7046 23.2881C26.5832 22.4095 26.5832 20.9953 26.5832 18.1668V16.9168V15.3202V13.5564V12.0835V10.8335C26.5832 8.00507 26.5832 6.59086 25.7046 5.71218C24.8259 4.8335 23.4117 4.8335 20.5832 4.8335H8.41657C5.58814 4.8335 4.17393 4.8335 3.29525 5.71218ZM14.3732 9.86253C14.0556 9.93264 13.8601 10.4385 13.469 11.4501C13.2467 12.0254 13.1355 12.313 12.9275 12.5087C12.8691 12.5636 12.8058 12.6124 12.7383 12.6546C12.4979 12.805 12.1977 12.8329 11.5973 12.8887C10.5811 12.9832 10.0729 13.0304 9.91776 13.3311C9.88562 13.3933 9.86377 13.4608 9.85312 13.5305C9.80167 13.8674 10.1752 14.2201 10.9223 14.9255L11.1298 15.1214C11.4791 15.4511 11.6537 15.616 11.7548 15.8218C11.8154 15.9453 11.856 16.0782 11.875 16.2153C11.9068 16.4439 11.8556 16.6831 11.7533 17.1615L11.7168 17.3325C11.5334 18.1904 11.4417 18.6194 11.5561 18.8303C11.659 19.0197 11.8484 19.1409 12.0577 19.1513C12.2906 19.1628 12.6189 18.8853 13.2753 18.3301C13.7079 17.9644 13.9241 17.7815 14.1642 17.7101C14.3836 17.6448 14.6162 17.6448 14.8356 17.7101C15.0757 17.7815 15.2919 17.9644 15.7245 18.3301C16.381 18.8853 16.7092 19.1628 16.9421 19.1513C17.1514 19.1409 17.3408 19.0197 17.4437 18.8303C17.5582 18.6194 17.4664 18.1904 17.283 17.3325L17.2465 17.1615C17.1442 16.6831 17.093 16.4439 17.1248 16.2153C17.1438 16.0782 17.1844 15.9453 17.245 15.8218C17.3461 15.616 17.5207 15.4511 17.87 15.1214L18.0775 14.9255C18.8246 14.2201 19.1981 13.8674 19.1467 13.5305C19.136 13.4608 19.1142 13.3933 19.082 13.3311C18.9269 13.0304 18.4187 12.9832 17.4025 12.8887C16.8021 12.8329 16.5019 12.805 16.2615 12.6546C16.194 12.6124 16.1307 12.5636 16.0723 12.5087C15.8643 12.313 15.7531 12.0254 15.5308 11.4501C15.1397 10.4385 14.9442 9.93264 14.6266 9.86253C14.5431 9.8441 14.4567 9.8441 14.3732 9.86253Z"
      fill={iconcolor}
    />
    <circle cx="25" cy="5" r="5" fill="#F3F5FD" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.75 5C28.75 7.07107 27.0711 8.75 25 8.75C22.9289 8.75 21.25 7.07107 21.25 5C21.25 2.92893 22.9289 1.25 25 1.25C27.0711 1.25 28.75 2.92893 28.75 5ZM25.4167 7.5C25.4167 7.73012 25.2301 7.91667 25 7.91667C24.7699 7.91667 24.5833 7.73012 24.5833 7.5C24.5833 7.26988 24.7699 7.08333 25 7.08333C25.2301 7.08333 25.4167 7.26988 25.4167 7.5ZM25 2.25C24.1716 2.25 23.5 2.92157 23.5 3.75H24C24 3.19772 24.4477 2.75 25 2.75H25.0393C25.5699 2.75 26 3.18012 26 3.71071V3.92453C26 4.21035 25.8171 4.46411 25.5459 4.5545C25.0706 4.71294 24.75 5.15777 24.75 5.65881V6.66667H25.25V5.65881C25.25 5.37298 25.4329 5.11922 25.7041 5.02884C26.1794 4.87039 26.5 4.42557 26.5 3.92453V3.71071C26.5 2.90398 25.846 2.25 25.0393 2.25H25Z"
      fill={iconcolor}
    />
  </svg>
);
StarBoxQuestionMarkIcon.propTypes = { iconcolor: PropTypes.string };

// export const AngryFaceIcon = () => (
//   <svg
//     width="35"
//     height="35"
//     viewBox="0 0 35 35"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <rect width="35" height="35" fill="#F3F5FD" />
//     <circle
//       cx="17.5"
//       cy="17.5"
//       r="14.125"
//       stroke="#D61E5C"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M11.7936 24.0356C12.4472 23.4696 13.3278 23.0456 14.3061 22.7632C15.2922 22.4785 16.3924 22.3332 17.5001 22.3332C18.6077 22.3332 19.7079 22.4785 20.6941 22.7632C21.6724 23.0456 22.553 23.4696 23.2066 24.0356"
//       stroke="#D61E5C"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M24.7917 11.6665L20.4167 14.5832"
//       stroke="#D61E5C"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M10.2083 11.6665L14.5833 14.5832"
//       stroke="#D61E5C"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M11.6666 16.2917C12.6101 16.2917 13.3749 15.5268 13.3749 14.5833C13.3749 13.6398 12.6101 12.875 11.6666 12.875C10.7231 12.875 9.95825 13.6398 9.95825 14.5833C9.95825 15.5268 10.7231 16.2917 11.6666 16.2917Z"
//       fill="#D61E5C"
//       stroke="#D61E5C"
//       strokeWidth="0.5"
//       strokeLinecap="round"
//     />
//     <path
//       d="M23.3333 16.2917C24.2768 16.2917 25.0417 15.5268 25.0417 14.5833C25.0417 13.6398 24.2768 12.875 23.3333 12.875C22.3898 12.875 21.625 13.6398 21.625 14.5833C21.625 15.5268 22.3898 16.2917 23.3333 16.2917Z"
//       fill="#D61E5C"
//       stroke="#D61E5C"
//       strokeWidth="0.5"
//       strokeLinecap="round"
//     />
//   </svg>
// );

// export const SadFaceIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="35"
//     height="35"
//     viewBox="0 0 35 35"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <rect width="35" height="35" fill="#F3F5FD" />
//     <circle
//       cx="17.5"
//       cy="17.5"
//       r="14.125"
//       stroke={iconcolor}
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M11.7936 24.0356C12.4472 23.4696 13.3278 23.0456 14.3061 22.7632C15.2922 22.4785 16.3924 22.3332 17.5001 22.3332C18.6077 22.3332 19.7079 22.4785 20.6941 22.7632C21.6724 23.0456 22.553 23.4696 23.2066 24.0356"
//       stroke={iconcolor}
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M13.1251 16.2917C14.0686 16.2917 14.8334 15.5268 14.8334 14.5833C14.8334 13.6398 14.0686 12.875 13.1251 12.875C12.1816 12.875 11.4167 13.6398 11.4167 14.5833C11.4167 15.5268 12.1816 16.2917 13.1251 16.2917Z"
//       fill={iconcolor}
//       stroke={iconcolor}
//       strokeWidth="0.5"
//       strokeLinecap="round"
//     />
//     <circle
//       cx="21.8751"
//       cy="14.5833"
//       r="1.70833"
//       fill={iconcolor}
//       stroke={iconcolor}
//       strokeWidth="0.5"
//       strokeLinecap="round"
//     />
//   </svg>
// );
// SadFaceIcon.propTypes = { iconcolor: PropTypes.string };

// export const NeutralFaceIcon = () => (
//   <svg
//     width="35"
//     height="35"
//     viewBox="0 0 35 35"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <rect width="35" height="35" fill="#F3F5FD" />
//     <circle
//       cx="17.5"
//       cy="17.5"
//       r="14.125"
//       stroke="#F0DA11"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M12.2367 24.1789C12.8154 24.0536 13.6052 23.9574 14.5114 23.8919C15.4254 23.826 16.4556 23.7917 17.5001 23.7917C18.5446 23.7917 19.5747 23.826 20.4887 23.8919C21.395 23.9574 22.1847 24.0536 22.7635 24.1789"
//       stroke="#F0DA11"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <mask
//       id="path-3-outside-1"
//       maskUnits="userSpaceOnUse"
//       x="10.6667"
//       y="13.125"
//       width="5"
//       height="4"
//       fill="black"
//     >
//       <rect fill="white" x="10.6667" y="13.125" width="5" height="4" />
//       <path d="M14.0834 14.5833C14.3268 14.5833 14.4485 14.5833 14.5232 14.6893C14.5979 14.7953 14.5648 14.8881 14.4985 15.0736C14.4266 15.2751 14.3105 15.4603 14.1563 15.6145C13.8828 15.888 13.5119 16.0417 13.1251 16.0417C12.7383 16.0417 12.3674 15.888 12.0939 15.6145C11.9397 15.4603 11.8236 15.2751 11.7516 15.0736C11.6854 14.8881 11.6523 14.7953 11.727 14.6893C11.8017 14.5833 11.9234 14.5833 12.1667 14.5833L13.1251 14.5833H14.0834Z" />
//     </mask>
//     <path
//       d="M14.0834 14.5833C14.3268 14.5833 14.4485 14.5833 14.5232 14.6893C14.5979 14.7953 14.5648 14.8881 14.4985 15.0736C14.4266 15.2751 14.3105 15.4603 14.1563 15.6145C13.8828 15.888 13.5119 16.0417 13.1251 16.0417C12.7383 16.0417 12.3674 15.888 12.0939 15.6145C11.9397 15.4603 11.8236 15.2751 11.7516 15.0736C11.6854 14.8881 11.6523 14.7953 11.727 14.6893C11.8017 14.5833 11.9234 14.5833 12.1667 14.5833L13.1251 14.5833H14.0834Z"
//       fill="#F0DA11"
//     />
//     <path
//       d="M14.0834 14.5833C14.3268 14.5833 14.4485 14.5833 14.5232 14.6893C14.5979 14.7953 14.5648 14.8881 14.4985 15.0736C14.4266 15.2751 14.3105 15.4603 14.1563 15.6145C13.8828 15.888 13.5119 16.0417 13.1251 16.0417C12.7383 16.0417 12.3674 15.888 12.0939 15.6145C11.9397 15.4603 11.8236 15.2751 11.7516 15.0736C11.6854 14.8881 11.6523 14.7953 11.727 14.6893C11.8017 14.5833 11.9234 14.5833 12.1667 14.5833L13.1251 14.5833H14.0834Z"
//       stroke="#F0DA11"
//       strokeLinecap="round"
//       mask="url(#path-3-outside-1)"
//     />
//     <mask
//       id="path-4-outside-2"
//       maskUnits="userSpaceOnUse"
//       x="19.4167"
//       y="13.125"
//       width="5"
//       height="4"
//       fill="black"
//     >
//       <rect fill="white" x="19.4167" y="13.125" width="5" height="4" />
//       <path d="M22.8334 14.5833C23.0768 14.5833 23.1985 14.5833 23.2732 14.6893C23.3479 14.7953 23.3148 14.8881 23.2485 15.0736C23.1766 15.2751 23.0605 15.4603 22.9063 15.6145C22.6328 15.888 22.2619 16.0417 21.8751 16.0417C21.4883 16.0417 21.1174 15.888 20.8439 15.6145C20.6897 15.4603 20.5736 15.2751 20.5016 15.0736C20.4354 14.8881 20.4023 14.7953 20.477 14.6893C20.5517 14.5833 20.6734 14.5833 20.9167 14.5833L21.8751 14.5833H22.8334Z" />
//     </mask>
//     <path
//       d="M22.8334 14.5833C23.0768 14.5833 23.1985 14.5833 23.2732 14.6893C23.3479 14.7953 23.3148 14.8881 23.2485 15.0736C23.1766 15.2751 23.0605 15.4603 22.9063 15.6145C22.6328 15.888 22.2619 16.0417 21.8751 16.0417C21.4883 16.0417 21.1174 15.888 20.8439 15.6145C20.6897 15.4603 20.5736 15.2751 20.5016 15.0736C20.4354 14.8881 20.4023 14.7953 20.477 14.6893C20.5517 14.5833 20.6734 14.5833 20.9167 14.5833L21.8751 14.5833H22.8334Z"
//       fill="#F0DA11"
//     />
//     <path
//       d="M22.8334 14.5833C23.0768 14.5833 23.1985 14.5833 23.2732 14.6893C23.3479 14.7953 23.3148 14.8881 23.2485 15.0736C23.1766 15.2751 23.0605 15.4603 22.9063 15.6145C22.6328 15.888 22.2619 16.0417 21.8751 16.0417C21.4883 16.0417 21.1174 15.888 20.8439 15.6145C20.6897 15.4603 20.5736 15.2751 20.5016 15.0736C20.4354 14.8881 20.4023 14.7953 20.477 14.6893C20.5517 14.5833 20.6734 14.5833 20.9167 14.5833L21.8751 14.5833H22.8334Z"
//       stroke="#F0DA11"
//       strokeLinecap="round"
//       mask="url(#path-4-outside-2)"
//     />
//   </svg>
// );

// export const HappyFaceIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="35"
//     height="35"
//     viewBox="0 0 35 35"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <rect width="35" height="35" fill="#F3F5FD" />
//     <circle
//       cx="17.5"
//       cy="17.5"
//       r="14.125"
//       stroke={iconcolor}
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M14.108 19.4585C14.4517 20.0539 14.9462 20.5483 15.5416 20.8921C16.137 21.2359 16.8124 21.4168 17.4999 21.4168C18.1874 21.4168 18.8628 21.2359 19.4583 20.8921C20.0537 20.5483 20.5481 20.0539 20.8919 19.4585"
//       stroke={iconcolor}
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <rect
//       x="10.0833"
//       y="11.5415"
//       width="4.625"
//       height="3.16667"
//       rx="1.58333"
//       fill={iconcolor}
//       stroke={iconcolor}
//       strokeWidth="0.25"
//       strokeLinecap="round"
//     />
//     <rect
//       x="20.2917"
//       y="11.5415"
//       width="4.625"
//       height="3.16667"
//       rx="1.58333"
//       fill={iconcolor}
//       stroke={iconcolor}
//       strokeWidth="0.25"
//       strokeLinecap="round"
//     />
//   </svg>
// );
// HappyFaceIcon.propTypes = { iconcolor: PropTypes.string };

// export const LaughingFaceIcon = ({ iconcolor = defaultColor }) => (
//   <svg
//     width="35"
//     height="35"
//     viewBox="0 0 35 35"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <rect width="35" height="35" fill="#F3F5FD" />
//     <circle
//       cx="17.5"
//       cy="17.5"
//       r="14.125"
//       stroke={iconcolor}
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//     <path
//       d="M13.1251 16.2917C14.0686 16.2917 14.8334 15.5268 14.8334 14.5833C14.8334 13.6398 14.0686 12.875 13.1251 12.875C12.1816 12.875 11.4167 13.6398 11.4167 14.5833C11.4167 15.5268 12.1816 16.2917 13.1251 16.2917Z"
//       fill={iconcolor}
//       stroke={iconcolor}
//       strokeWidth="0.5"
//       strokeLinecap="round"
//     />
//     <circle
//       cx="21.8751"
//       cy="14.5833"
//       r="1.70833"
//       fill={iconcolor}
//       stroke={iconcolor}
//       strokeWidth="0.5"
//       strokeLinecap="round"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M12.3141 21.875C12.0357 21.875 11.8965 21.875 11.8215 21.9758C11.7465 22.0767 11.7837 22.2004 11.8582 22.448C12.5161 24.6362 14.7926 26.25 17.5 26.25C20.2073 26.25 22.4839 24.6362 23.1418 22.448C23.2162 22.2004 23.2534 22.0767 23.1784 21.9758C23.1035 21.875 22.9643 21.875 22.6859 21.875H12.3141Z"
//       fill={iconcolor}
//     />
//   </svg>
// );
// LaughingFaceIcon.propTypes = { iconcolor: PropTypes.string };

export const CaretDownIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7071 0.292893C14.0976 0.683418 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292892 1.70711C-0.0976315 1.31658 -0.0976315 0.683417 0.292892 0.292893C0.683417 -0.0976317 1.31658 -0.0976317 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976312 13.3166 -0.0976311 13.7071 0.292893Z"
      fill={iconcolor}
    />
  </svg>
);
CaretDownIcon.propTypes = { iconcolor: PropTypes.string };

export const CaretUpIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.292893 7.70711C-0.0976311 7.31658 -0.0976312 6.68342 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976317 7.31658 -0.0976318 7.70711 0.292893L13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711C13.3166 8.09763 12.6834 8.09763 12.2929 7.70711L7 2.41421L1.70711 7.70711C1.31658 8.09763 0.683418 8.09763 0.292893 7.70711Z"
      fill={iconcolor}
    />
  </svg>
);
CaretUpIcon.propTypes = { iconcolor: PropTypes.string };

export const SortIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 320 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
      fill={iconcolor}
    />
  </svg>
);
SortIcon.propTypes = { iconcolor: PropTypes.string };

export const SortUpIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 320 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
      fill={iconcolor}
    />
  </svg>
);
SortUpIcon.propTypes = { iconcolor: PropTypes.string };

export const SortDownIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 320 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
      fill={iconcolor}
    />
  </svg>
);
SortDownIcon.propTypes = { iconcolor: PropTypes.string };

export const EditIcon = ({ iconcolor = defaultColor }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9362 6.17043L13.3375 4.76921C13.4667 4.63998 13.5313 4.57537 13.5816 4.51663C14.2227 3.76792 14.2227 2.66375 13.5816 1.91503C13.5313 1.8563 13.4667 1.79168 13.3375 1.66245L13.3374 1.66243C13.2082 1.53322 13.1436 1.46861 13.0849 1.41832C12.3362 0.777228 11.232 0.777228 10.4833 1.41832C10.4245 1.46861 10.3599 1.53322 10.2307 1.66243L10.2307 1.66245L9.09456 2.79859C9.74511 4.14554 10.7244 5.30477 11.9362 6.17043ZM10.5061 7.60053C9.32753 6.70304 8.34211 5.57293 7.61321 4.27994L2.54349 9.34966C2.11843 9.77472 1.9059 9.98725 1.76616 10.2484C1.62643 10.5094 1.56748 10.8042 1.44959 11.3936L1.0575 13.3541C0.990982 13.6867 0.957721 13.853 1.05233 13.9476C1.14694 14.0422 1.31324 14.0089 1.64585 13.9424L3.60628 13.5503C4.19573 13.4324 4.49046 13.3735 4.75156 13.2337C5.01265 13.094 5.22518 12.8815 5.65024 12.4564L10.5061 7.60053Z"
      fill={iconcolor}
    />
  </svg>
);
EditIcon.propTypes = { iconcolor: PropTypes.string };

export const ExclamationCircleOutlined = ({ className = '', iconcolor = 'currentColor' }) => (
  <svg
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="exclamation-circle"
    width="1em"
    height="1em"
    fill={iconcolor}
    aria-hidden="true"
    className={className}
  >
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
    <path d="M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" />
  </svg>
);
ExclamationCircleOutlined.propTypes = { className: PropTypes.string, iconcolor: PropTypes.string };

export const DashboardIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 2C0 0.89543 0.895431 0 2 0H6C7.10457 0 8 0.895431 8 2V7C8 8.10457 7.10457 9 6 9H2C0.895431 9 0 8.10457 0 7V2Z"
      fill="white"
    />
    <path
      d="M10 11C10 9.89543 10.8954 9 12 9H16C17.1046 9 18 9.89543 18 11V16C18 17.1046 17.1046 18 16 18H12C10.8954 18 10 17.1046 10 16V11Z"
      fill="white"
    />
    <rect x="10" width="8" height="7" rx="2" fill="white" />
    <rect y="11" width="8" height="7" rx="2" fill="white" />
  </svg>
);

export const HomeIcon = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.01262 9.65095C2 9.97853 2 10.3594 2 10.8054V16.3801C2 17.1437 2 17.5255 2.25334 17.7628C2.50668 18 2.91442 18 3.7299 18H6.64286V14.4636C6.64286 14.0162 7.03011 13.6536 7.50781 13.6536H9.49219C9.96989 13.6536 10.3571 14.0162 10.3571 14.4636V18H13.2701C14.0856 18 14.4933 18 14.7467 17.7628C15 17.5255 15 17.1437 15 16.3801V10.8054C15 10.3594 15 9.97853 14.9874 9.65095C14.5604 9.65079 14.1202 9.64067 13.7212 9.52616C13.3361 9.41562 12.9827 9.23558 12.6786 9C12.208 9.36458 11.6196 9.59641 10.9803 9.64231C10.8627 9.65075 10.7386 9.65068 10.6201 9.65062L10.5893 9.65061L10.5585 9.65062C10.4399 9.65068 10.3158 9.65075 10.1983 9.64231C9.55901 9.59641 8.97057 9.36458 8.5 9C8.02943 9.36458 7.44099 9.59641 6.80171 9.64231C6.68416 9.65075 6.56006 9.65068 6.44149 9.65062L6.41071 9.65061L6.37994 9.65062C6.26137 9.65068 6.13727 9.65075 6.01972 9.64231C5.38043 9.59641 4.79199 9.36458 4.32143 9C4.01735 9.23558 3.66394 9.41562 3.27881 9.52616C2.87983 9.64067 2.43962 9.65079 2.01262 9.65095Z"
      fill="#B6CD1E"
    />
    <path
      d="M1.34474 1.41112C1.50962 0.733418 1.59206 0.394564 1.83795 0.197282C2.08383 0 2.42373 0 3.10353 0H13.8965C14.5763 0 14.9162 0 15.1621 0.197282C15.4079 0.394564 15.4904 0.733418 15.6553 1.41112L16.8518 6.32926C16.9649 6.79433 17.0215 7.02687 16.9925 7.21459C16.9435 7.53126 16.7395 7.79979 16.4524 7.92541C16.2822 7.99988 16.0444 7.99988 15.5689 7.99988C14.9429 7.99988 14.6299 7.99988 14.3702 7.9181C13.8952 7.76849 13.5007 7.42512 13.279 6.96823C13.1578 6.71847 13.1073 6.40714 13.0064 5.78448C12.9781 5.61019 12.964 5.52304 12.9448 5.50235C12.9091 5.46371 12.8491 5.46371 12.8134 5.50235C12.7943 5.52304 12.7801 5.61019 12.7519 5.78447L12.6725 6.27369C12.6466 6.43359 12.6336 6.51353 12.617 6.58278C12.4297 7.36372 11.7758 7.93294 10.9954 7.99443C10.9262 7.99988 10.8473 7.99988 10.6896 7.99988C10.5318 7.99988 10.4529 7.99988 10.3837 7.99443C9.60332 7.93294 8.94943 7.36372 8.7621 6.58278C8.74549 6.51353 8.73253 6.43359 8.70659 6.27369L8.62725 5.78448C8.59898 5.61019 8.58484 5.52304 8.56571 5.50235C8.52997 5.46371 8.47003 5.46371 8.43429 5.50235C8.41515 5.52304 8.40102 5.61019 8.37275 5.78447L8.2934 6.27369C8.26747 6.43359 8.25451 6.51353 8.23789 6.58278C8.05057 7.36372 7.39667 7.93294 6.61626 7.99443C6.54706 7.99988 6.46819 7.99988 6.31044 7.99988C6.1527 7.99988 6.07383 7.99988 6.00463 7.99443C5.22421 7.93294 4.57032 7.36372 4.38299 6.58278C4.36638 6.51353 4.35342 6.43359 4.32748 6.27369L4.24814 5.78448C4.21987 5.61019 4.20574 5.52304 4.1866 5.50235C4.15086 5.46371 4.09092 5.46371 4.05518 5.50235C4.03605 5.52304 4.02191 5.61019 3.99364 5.78448C3.89265 6.40714 3.84216 6.71847 3.72097 6.96823C3.49927 7.42512 3.10482 7.76849 2.6298 7.9181C2.37014 7.99988 2.05712 7.99988 1.43107 7.99988C0.955552 7.99988 0.717792 7.99988 0.547614 7.92541C0.260529 7.79979 0.0565026 7.53126 0.00753118 7.21459C-0.0214981 7.02687 0.0350756 6.79433 0.148223 6.32926L1.34474 1.41112Z"
      fill="#B6CD1E"
    />
  </svg>
);

// export const DoublePaperIcon = () => (
//   <svg
//     width="16"
//     height="18"
//     viewBox="0 0 16 18"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M0.838905 2.44043C0.37559 2.44043 0 2.81602 0 3.27933V17.1613C0 17.6246 0.37559 18.0002 0.838904 18.0002H12.1028C12.5661 18.0002 12.9417 17.6246 12.9417 17.1613V3.27933C12.9417 2.81602 12.5661 2.44043 12.1028 2.44043H0.838905ZM3.32474 6.47119C3.00786 6.47119 2.75098 6.72807 2.75098 7.04495C2.75098 7.36183 3.00786 7.61871 3.32474 7.61871H9.61729C9.93416 7.61871 10.191 7.36183 10.191 7.04495C10.191 6.72807 9.93416 6.47119 9.61729 6.47119H3.32474ZM2.75098 10.4961C2.75098 10.1792 3.00786 9.92236 3.32474 9.92236H9.61729C9.93416 9.92236 10.191 10.1792 10.191 10.4961C10.191 10.813 9.93416 11.0699 9.61729 11.0699H3.32474C3.00786 11.0699 2.75098 10.813 2.75098 10.4961ZM3.32474 13.3735C3.00786 13.3735 2.75098 13.6304 2.75098 13.9473C2.75098 14.2642 3.00786 14.5211 3.32474 14.5211H7.04267C7.35955 14.5211 7.61643 14.2642 7.61643 13.9473C7.61643 13.6304 7.35955 13.3735 7.04267 13.3735H3.32474Z"
//       fill="#B6CD1E"
//     />
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M4.66801 0C4.20469 0 3.8291 0.37559 3.8291 0.838904V1.42529H13.18C13.6433 1.42529 14.0189 1.80088 14.0189 2.2642V15.5598H15.1614C15.6247 15.5598 16.0003 15.1842 16.0003 14.7209V0.838905C16.0003 0.37559 15.6247 0 15.1614 0H4.66801Z"
//       fill="#B6CD1E"
//     />
//   </svg>
// );

export const UniversityHatIcon = () => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.69727 5.57617C3.69726 5.30003 3.47341 5.07617 3.19726 5.07617C2.92112 5.07617 2.69726 5.30003 2.69727 5.57617L2.6973 14.3024C1.89305 14.5201 1.30176 15.2505 1.30176 16.1182C1.30176 17.1575 2.15021 18 3.19683 18C4.24345 18 5.0919 17.1575 5.0919 16.1182C5.0919 15.2509 4.50107 14.5206 3.6973 14.3026L3.69727 5.57617Z"
      fill="#B6CD1E"
    />
    <path
      d="M0.658286 3.692C0.466286 3.636 0.466286 3.364 0.658286 3.308L11.16 0.245C11.7086 0.085 12.2914 0.085 12.84 0.245L23.3417 3.308C23.5337 3.364 23.5337 3.636 23.3417 3.692L12.84 6.755C12.2914 6.915 11.7086 6.915 11.16 6.755L0.658286 3.692Z"
      fill="#B6CD1E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.57274 7H6V13.1354C6 13.1354 8.72727 15 12 15C15.2727 15 18 13.1354 18 13.1354V7H16.4273L12.9784 8.03941C12.3436 8.23072 11.6565 8.23072 11.0217 8.03941L7.57274 7Z"
      fill="#B6CD1E"
    />
  </svg>
);

export const CertificateIcon = () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9015 13.05C19.5821 12.3694 20 11.4478 20 10.4332C20 8.33874 18.2194 6.64087 16.023 6.64087C13.8265 6.64087 12.0459 8.33874 12.0459 10.4332C12.0459 11.4382 12.4559 12.3519 13.125 13.0305V17.4492C13.125 17.5515 13.1549 17.6518 13.2113 17.7388C13.2677 17.8258 13.3484 17.8961 13.4444 17.9419C13.5403 17.9876 13.6477 18.007 13.7546 17.9978C13.8614 17.9886 13.9635 17.9513 14.0493 17.8899L15.6667 16.7332C15.7667 16.6617 15.8883 16.623 16.0133 16.623C16.1383 16.623 16.2599 16.6617 16.3599 16.7332L17.9773 17.8899C18.0631 17.9513 18.1651 17.9886 18.272 17.9978C18.3788 18.007 18.4862 17.9876 18.5822 17.9419C18.6781 17.8961 18.7588 17.8258 18.8152 17.7388C18.8716 17.6518 18.9015 17.5515 18.9015 17.4492V13.05Z"
      fill="#B6CD1E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.83716 0C0.822524 0 0 0.822524 0 1.83716V11.4435C0 12.4581 0.822528 13.2807 1.83716 13.2807H12.1375C11.4884 12.4981 11.101 11.5093 11.101 10.4341C11.101 7.89776 13.2573 5.84165 15.9172 5.84165C17.0444 5.84165 18.0813 6.21094 18.9018 6.82958V1.83716C18.9018 0.822524 18.0793 0 17.0647 0H1.83716ZM3.48157 4.02642C3.48157 3.83772 3.54446 3.65676 3.6564 3.52334C3.76834 3.38991 3.92017 3.31495 4.07847 3.31495H14.8227C14.981 3.31495 15.1328 3.38991 15.2447 3.52334C15.3567 3.65676 15.4196 3.83772 15.4196 4.02642C15.4196 4.21511 15.3567 4.39607 15.2447 4.5295C15.1328 4.66292 14.981 4.73788 14.8227 4.73788H4.07847C3.92017 4.73788 3.76834 4.66292 3.6564 4.5295C3.54446 4.39607 3.48157 4.21511 3.48157 4.02642ZM3.6562 7.59777C3.76814 7.46434 3.91997 7.38938 4.07827 7.38938H8.85347C9.01178 7.38938 9.1636 7.46434 9.27554 7.59777C9.38748 7.73119 9.45037 7.91216 9.45037 8.10085C9.45037 8.28954 9.38748 8.4705 9.27554 8.60393C9.1636 8.73735 9.01178 8.81231 8.85347 8.81231H4.07827C3.91997 8.81231 3.76814 8.73735 3.6562 8.60393C3.54426 8.4705 3.48137 8.28954 3.48137 8.10085C3.48137 7.91216 3.54426 7.73119 3.6562 7.59777Z"
      fill="#B6CD1E"
    />
  </svg>
);

export const ListIcon = () => (
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.585786 0.585786C0 1.17157 0 2.11438 0 4V13C0 14.8856 0 15.8284 0.585786 16.4142C1.17157 17 2.11438 17 4 17H10C11.8856 17 12.8284 17 13.4142 16.4142C14 15.8284 14 14.8856 14 13V4C14 2.11438 14 1.17157 13.4142 0.585786C12.8284 0 11.8856 0 10 0H4C2.11438 0 1.17157 0 0.585786 0.585786ZM4 4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6H10C10.5523 6 11 5.55228 11 5C11 4.44772 10.5523 4 10 4H4ZM4 8C3.44772 8 3 8.44772 3 9C3 9.55228 3.44772 10 4 10H10C10.5523 10 11 9.55228 11 9C11 8.44772 10.5523 8 10 8H4ZM4 12C3.44772 12 3 12.4477 3 13C3 13.5523 3.44772 14 4 14H8C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12H4Z"
      fill="#B6CD1E"
    />
  </svg>
);

export const TrashIcon = ({ className = '' }) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_74:4634)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.39751 1.04296C7.12735 0.977683 6.81288 0.945557 6.50028 0.945557C6.18768 0.945557 5.87321 0.977683 5.60305 1.04296C5.46799 1.0756 5.33625 1.11835 5.21724 1.17444C5.10889 1.2255 4.96279 1.30956 4.83965 1.45429C4.58996 1.74775 4.5764 2.24063 4.80937 2.55516C5.02995 2.85296 5.39245 2.88411 5.64233 2.63749C5.64471 2.63629 5.64747 2.63494 5.65061 2.63346C5.68637 2.6166 5.74712 2.59435 5.83604 2.57286C6.01384 2.5299 6.24824 2.50335 6.50028 2.50335C6.75232 2.50335 6.98671 2.5299 7.16452 2.57286C7.25344 2.59435 7.31419 2.6166 7.34995 2.63346C7.35309 2.63494 7.35584 2.63629 7.35823 2.63749C7.6081 2.88411 7.97061 2.85296 8.19119 2.55516C8.42416 2.24063 8.4106 1.74775 8.1609 1.45429C8.03776 1.30956 7.89167 1.2255 7.78332 1.17444C7.66431 1.11835 7.53256 1.0756 7.39751 1.04296Z"
        fill="#E84427"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 3.73169H0V5.77455C0.797745 5.77455 1.44444 6.42125 1.44444 7.219V9.04313C1.44444 11.0259 1.44444 12.0173 1.92615 12.7261C2.1235 13.0165 2.37396 13.2669 2.66435 13.4643C3.37316 13.946 4.36454 13.946 6.3473 13.946H6.6527C8.63546 13.946 9.62684 13.946 10.3356 13.4643C10.626 13.2669 10.8765 13.0165 11.0739 12.7261C11.5556 12.0173 11.5556 11.0259 11.5556 9.04313V7.219C11.5556 6.42125 12.2023 5.77455 13 5.77455V3.73169ZM5.17993 7.35273C5.17993 7.09049 4.96734 6.87789 4.7051 6.87789C4.44285 6.87789 4.23026 7.09049 4.23026 7.35273V11.0459C4.23026 11.3082 4.44285 11.5208 4.7051 11.5208C4.96734 11.5208 5.17993 11.3082 5.17993 11.0459V7.35273ZM8.87312 7.35273C8.87312 7.09049 8.66052 6.87789 8.39828 6.87789C8.13603 6.87789 7.92344 7.09049 7.92344 7.35273V11.0459C7.92344 11.3082 8.13603 11.5208 8.39828 11.5208C8.66052 11.5208 8.87312 11.3082 8.87312 11.0459V7.35273Z"
        fill="#E84427"
      />
    </g>
    <defs>
      <clipPath id="clip0_74:4634">
        <rect
          width="13"
          height="12.9293"
          fill="white"
          transform="translate(0 0.945557)"
        />
      </clipPath>
    </defs>
  </svg>
);
TrashIcon.propTypes = { className: PropTypes.string };

export const RestoreIcon = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="3 3 44 44"
    fill="none"
    className={className}
  >
    <path d="M25.99 6C16.04 6 8 14.06 8 24H2l7.79 7.79.14.29L18 24h-6c0-7.73 6.27-14 14-14s14 6.27 14 14-6.27 14-14 14c-3.87 0-7.36-1.58-9.89-4.11l-2.83 2.83C16.53 39.98 21.02 42 25.99 42 35.94 42 44 33.94 44 24S35.94 6 25.99 6zM24 16v10l8.56 5.08L34 28.65l-7-4.15V16h-3z" />
  </svg>
);
RestoreIcon.propTypes = { className: PropTypes.string };

export const StarIcon = ({ iconcolor = defaultColor, strokecolor = '' }) => (
  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.52447 1.08156C6.67415 0.620904 7.32585 0.620906 7.47553 1.08156L8.32058 3.68237C8.52139 4.30041 9.09733 4.71885 9.74717 4.71885H12.4818C12.9662 4.71885 13.1676 5.33866 12.7757 5.62336L10.5633 7.23075C10.0376 7.61271 9.81762 8.28976 10.0184 8.9078L10.8635 11.5086C11.0132 11.9693 10.4859 12.3523 10.0941 12.0676L7.88168 10.4602C7.35595 10.0783 6.64405 10.0783 6.11832 10.4602L3.90594 12.0676C3.51408 12.3523 2.98684 11.9693 3.13652 11.5086L3.98157 8.9078C4.18238 8.28976 3.9624 7.61271 3.43667 7.23075L1.22428 5.62336C0.832426 5.33865 1.03382 4.71885 1.51818 4.71885H4.25283C4.90267 4.71885 5.4786 4.30041 5.67942 3.68237L6.52447 1.08156Z"
      fill={strokecolor}
      stroke={iconcolor}
    />
  </svg>
);
StarIcon.propTypes = { iconcolor: PropTypes.string, strokecolor: PropTypes.string };

export const DeleteIcon = ({ iconcolor = defaultColor, strokecolor = '#28367B' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
    <path
      d="M13.05 42Q11.85 42 10.95 41.1Q10.05 40.2 10.05 39V10.5H8V7.5H17.4V6H30.6V7.5H40V10.5H37.95V39Q37.95 40.2 37.05 41.1Q36.15 42 34.95 42ZM34.95 10.5H13.05V39Q13.05 39 13.05 39Q13.05 39 13.05 39H34.95Q34.95 39 34.95 39Q34.95 39 34.95 39ZM18.35 34.7H21.35V14.75H18.35ZM26.65 34.7H29.65V14.75H26.65ZM13.05 10.5V39Q13.05 39 13.05 39Q13.05 39 13.05 39Q13.05 39 13.05 39Q13.05 39 13.05 39Z"
      fill={iconcolor}
      stroke={strokecolor}
    />
  </svg>
);
DeleteIcon.propTypes = { iconcolor: PropTypes.string, strokecolor: PropTypes.string };

export const VisibilityIcon = ({ iconcolor = defaultColor, strokecolor = '#28367B' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
    <path
      d="M24 31.5Q27.55 31.5 30.025 29.025Q32.5 26.55 32.5 23Q32.5 19.45 30.025 16.975Q27.55 14.5 24 14.5Q20.45 14.5 17.975 16.975Q15.5 19.45 15.5 23Q15.5 26.55 17.975 29.025Q20.45 31.5 24 31.5ZM24 28.6Q21.65 28.6 20.025 26.975Q18.4 25.35 18.4 23Q18.4 20.65 20.025 19.025Q21.65 17.4 24 17.4Q26.35 17.4 27.975 19.025Q29.6 20.65 29.6 23Q29.6 25.35 27.975 26.975Q26.35 28.6 24 28.6ZM24 38Q16.7 38 10.8 33.85Q4.9 29.7 2 23Q4.9 16.3 10.8 12.15Q16.7 8 24 8Q31.3 8 37.2 12.15Q43.1 16.3 46 23Q43.1 29.7 37.2 33.85Q31.3 38 24 38ZM24 23Q24 23 24 23Q24 23 24 23Q24 23 24 23Q24 23 24 23Q24 23 24 23Q24 23 24 23Q24 23 24 23Q24 23 24 23ZM24 35Q30.05 35 35.125 31.725Q40.2 28.45 42.85 23Q40.2 17.55 35.125 14.275Q30.05 11 24 11Q17.95 11 12.875 14.275Q7.8 17.55 5.1 23Q7.8 28.45 12.875 31.725Q17.95 35 24 35Z"
      fill={iconcolor}
      stroke={strokecolor}
    />
  </svg>
);
VisibilityIcon.propTypes = { iconcolor: PropTypes.string, strokecolor: PropTypes.string };

export const CrossIcon = ({ iconcolor = undefined, className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" height="14" width="14" className={className}>
    <path
      d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
      fill={iconcolor}
    />
  </svg>
);
CrossIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const PrinterIcon = ({ iconcolor = '', onClick = () => {}, className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={iconcolor} className={className} viewBox="0 0 16 16" onClick={onClick}>
    <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
    <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
  </svg>
);
PrinterIcon.propTypes = { iconcolor: PropTypes.string, onClick: PropTypes.func, className: PropTypes.string };

export const InfoIcon = ({ iconcolor = '', className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={iconcolor} className={className} viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
  </svg>
);
InfoIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const AccountBanIcon = ({ iconcolor = '', className = '' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21C14.0822 21 16.1 20.278 17.7095 18.9571C19.3191 17.6362 20.4209 15.798 20.8271 13.7558C21.2333 11.7136 20.9188 9.59376 19.9373 7.75743C18.9558 5.9211 17.3679 4.48191 15.4442 3.68508C13.5205 2.88826 11.38 2.78311 9.38744 3.38754C7.3949 3.99197 5.67358 5.26858 4.51677 6.99987C3.35997 8.73115 2.83925 10.81 3.04334 12.8822C3.24743 14.9543 4.1637 16.8916 5.63604 18.364" stroke={iconcolor} strokeWidth="2" strokeLinecap="round" />
    <path d="M9 9L15 15" stroke={iconcolor} strokeWidth="2" strokeLinecap="round" />
    <path d="M15 9L9 15" stroke={iconcolor} strokeWidth="2" strokeLinecap="round" />
  </svg>
);
AccountBanIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const AccountActivityIcon = ({ iconcolor = '', className = '' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke={iconcolor} strokeWidth="2" />
    <path d="M8 12L11 15L16 9" stroke={iconcolor} strokeWidth="2" />
  </svg>
);
AccountActivityIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const AccountVerificationIcon = ({ iconcolor = '', className = '' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21C14.0822 21 16.1 20.278 17.7095 18.9571C19.3191 17.6362 20.4209 15.798 20.8271 13.7558C21.2333 11.7136 20.9188 9.59376 19.9373 7.75743C18.9558 5.9211 17.3679 4.48191 15.4442 3.68508C13.5205 2.88826 11.38 2.78311 9.38744 3.38754C7.3949 3.99197 5.67358 5.26858 4.51677 6.99987C3.35997 8.73115 2.83925 10.81 3.04334 12.8822C3.24743 14.9543 4.1637 16.8916 5.63604 18.364" stroke={iconcolor} strokeWidth="2" strokeLinecap="round" />
    <path d="M16 10L12.402 14.3175C11.7465 15.1042 11.4187 15.4976 10.9781 15.5176C10.5375 15.5375 10.1755 15.1755 9.45139 14.4514L8 13" stroke={iconcolor} strokeWidth="2" strokeLinecap="round" />
  </svg>
);
AccountVerificationIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const AccountRegistrationUnfinishedIcon = ({ iconcolor = '', className = '' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21C14.0822 21 16.1 20.278 17.7095 18.9571C19.3191 17.6362 20.4209 15.798 20.8271 13.7558C21.2333 11.7136 20.9188 9.59376 19.9373 7.75743C18.9558 5.9211 17.3679 4.48191 15.4442 3.68508C13.5205 2.88826 11.38 2.78311 9.38744 3.38754C7.3949 3.99197 5.67358 5.26858 4.51677 6.99987C3.35997 8.73115 2.83925 10.81 3.04334 12.8822C3.24743 14.9543 4.1637 16.8916 5.63604 18.364" stroke={iconcolor} strokeWidth="2" strokeLinecap="round" />
    <path d="M16 10L12.402 14.3175C11.7465 15.1042 11.4187 15.4976 10.9781 15.5176C10.5375 15.5375 10.1755 15.1755 9.45139 14.4514L8 13" stroke={iconcolor} strokeWidth="2" strokeLinecap="round" />
  </svg>
);
AccountRegistrationUnfinishedIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const AccountAdminIcon = ({ iconcolor = '', className = '' }) => (

  <svg width="16" height="22" viewBox="0 0 16 22" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M5.68 12.19L8 10.43L10.31 12.19L9.43 9.34L11.75 7.5H8.91L8 4.69L7.09 7.5H4.25L6.56 9.34L5.68 12.19ZM16 8.5C16 4.08 12.42 0.5 8 0.5C3.58 0.5 0 4.08 0 8.5C0 10.53 0.76 12.37 2 13.78V21.5L8 19.5L14 21.5V13.78C15.24 12.37 16 10.53 16 8.5ZM8 2.5C11.31 2.5 14 5.19 14 8.5C14 11.81 11.31 14.5 8 14.5C4.69 14.5 2 11.81 2 8.5C2 5.19 4.69 2.5 8 2.5ZM8 17.5L4 18.52V15.42C5.18 16.1 6.54 16.5 8 16.5C9.46 16.5 10.82 16.1 12 15.42V18.52L8 17.5Z" fill="black" stroke={iconcolor} />
  </svg>
);
AccountAdminIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const AccountCompanyIcon = ({ iconcolor = '', className = '' }) => (

  <svg width="22" height="18" viewBox="0 0 22 18" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M8.04688 12C5.37687 12 0.046875 13.34 0.046875 16V18H16.0469V16C16.0469 13.34 10.7169 12 8.04688 12ZM2.04688 16C2.26688 15.28 5.35687 14 8.04688 14C10.7469 14 13.8469 15.29 14.0469 16H2.04688Z" fill="black" stroke={iconcolor} />
    <path d="M3.78687 6H4.04688C4.04688 8.21 5.83687 10 8.04688 10C10.2569 10 12.0469 8.21 12.0469 6H12.3069C12.5769 6 12.7969 5.78 12.7969 5.51V5.49C12.7969 5.22 12.5769 5 12.3069 5H12.0469C12.0469 3.52 11.2369 2.25 10.0469 1.55V2.5C10.0469 2.78 9.82687 3 9.54688 3C9.26688 3 9.04688 2.78 9.04688 2.5V1.14C8.72688 1.06 8.39688 1 8.04688 1C7.69688 1 7.36688 1.06 7.04688 1.14V2.5C7.04688 2.78 6.82688 3 6.54688 3C6.26687 3 6.04688 2.78 6.04688 2.5V1.55C4.85687 2.25 4.04688 3.52 4.04688 5H3.78687C3.51687 5 3.29688 5.22 3.29688 5.49V5.52C3.29688 5.78 3.51687 6 3.78687 6ZM10.0469 6C10.0469 7.1 9.14688 8 8.04688 8C6.94688 8 6.04688 7.1 6.04688 6H10.0469Z" fill="black" stroke={iconcolor} />
    <path d="M21.0269 3.23L21.9569 2.4L21.2069 1.1L20.0169 1.49C19.8769 1.38 19.7169 1.29 19.5469 1.22L19.2969 0H17.7969L17.5469 1.22C17.3769 1.29 17.2169 1.38 17.0669 1.49L15.8869 1.1L15.1369 2.4L16.0669 3.23C16.0469 3.4 16.0469 3.58 16.0669 3.75L15.1369 4.6L15.8869 5.9L17.0869 5.52C17.2169 5.62 17.3669 5.7 17.5169 5.77L17.7969 7H19.2969L19.5669 5.78C19.7269 5.71 19.8669 5.63 20.0069 5.53L21.1969 5.91L21.9469 4.61L21.0169 3.76C21.0469 3.57 21.0369 3.4 21.0269 3.23ZM18.5469 4.75C17.8569 4.75 17.2969 4.19 17.2969 3.5C17.2969 2.81 17.8569 2.25 18.5469 2.25C19.2369 2.25 19.7969 2.81 19.7969 3.5C19.7969 4.19 19.2369 4.75 18.5469 4.75Z" fill="black" stroke={iconcolor} />
    <path d="M18.4469 7.79L17.5969 8.07C17.4969 7.99 17.3869 7.93 17.2669 7.88L17.0869 7H16.0169L15.8369 7.87C15.7169 7.92 15.5969 7.99 15.4969 8.06L14.6569 7.78L14.1169 8.71L14.7769 9.3C14.7669 9.43 14.7669 9.55 14.7769 9.67L14.1169 10.28L14.6569 11.21L15.5169 10.94C15.6169 11.01 15.7169 11.07 15.8269 11.12L16.0069 12H17.0769L17.2669 11.13C17.3769 11.08 17.4869 11.02 17.5869 10.95L18.4369 11.22L18.9769 10.29L18.3169 9.68C18.3269 9.55 18.3269 9.43 18.3169 9.31L18.9769 8.72L18.4469 7.79ZM16.5469 10.39C16.0569 10.39 15.6569 9.99 15.6569 9.5C15.6569 9.01 16.0569 8.61 16.5469 8.61C17.0369 8.61 17.4369 9.01 17.4369 9.5C17.4369 9.99 17.0369 10.39 16.5469 10.39Z" fill="black" stroke={iconcolor} />
  </svg>
);
AccountCompanyIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const ThumbsUpIcon = ({ iconcolor = '', className = '' }) => (

  <svg width="22" height="18" fill="none" className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z" fill={iconcolor} />
  </svg>
);
ThumbsUpIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const ThumbsDownIcon = ({ iconcolor = '', className = '' }) => (
  <svg width="22" height="18" fill="none" className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z" fill={iconcolor} />
  </svg>
);
ThumbsDownIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const CZFlagIcon = () => (
  <svg viewBox="0 0 900 600" width="16" height="22">
    <rect width="900" height="300" fill="#fff" />
    <rect width="900" height="300" y="300" fill="#d7141a" />
    <path d="M 450,300 0,0 V 600 z" fill="#11457e" />
  </svg>
);

export const UAFlagIcon = () => (
  <svg viewBox="0 0 900 600" width="16" height="22">
    <rect width="1200" height="400" fill="#005BBB" />
    <rect width="1200" height="400" y="400" fill="#FFD500" />
  </svg>
);

export const FrogIcon = ({ iconcolor = '', className = '' }) => (
  <svg width="15" height="15" fill="none" className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path fill={iconcolor} d="M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z" />
  </svg>
);
FrogIcon.propTypes = { iconcolor: PropTypes.string, className: PropTypes.string };

export const MaleIcon = ({ className = 'fill-base-front-3' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.666 2.66675H9.99935C9.63268 2.66675 9.33268 2.96675 9.33268 3.33341C9.33268 3.70008 9.63268 4.00008 9.99935 4.00008H11.0527L8.40602 6.64675C7.81935 6.24008 7.10602 6.00008 6.33268 6.00008C4.30602 6.00008 2.66602 7.64008 2.66602 9.66675C2.66602 11.6934 4.30602 13.3334 6.33268 13.3334C8.35935 13.3334 9.99935 11.6934 9.99935 9.66675C9.99935 8.89341 9.75935 8.18008 9.35268 7.58675L11.9993 4.94675V6.00008C11.9993 6.36675 12.2993 6.66675 12.666 6.66675C13.0327 6.66675 13.3327 6.36675 13.3327 6.00008V3.33341C13.3327 2.96675 13.0327 2.66675 12.666 2.66675ZM6.33268 12.0001C5.04602 12.0001 3.99935 10.9534 3.99935 9.66675C3.99935 8.38008 5.04602 7.33342 6.33268 7.33342C7.61935 7.33342 8.66602 8.38008 8.66602 9.66675C8.66602 10.9534 7.61935 12.0001 6.33268 12.0001Z" />
  </svg>
);
MaleIcon.propTypes = { className: PropTypes.string };

export const FemaleIcon = ({ className = 'fill-base-front-3' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.00065 3.66659C9.28732 3.66659 10.334 4.71325 10.334 5.99992C10.334 7.28659 9.28732 8.33325 8.00065 8.33325C6.71398 8.33325 5.66732 7.28659 5.66732 5.99992C5.66732 4.71325 6.71398 3.66659 8.00065 3.66659ZM8.66732 9.60659C10.374 9.29325 11.6673 7.79992 11.6673 5.99992C11.6673 3.97325 10.0273 2.33325 8.00065 2.33325C5.97398 2.33325 4.33398 3.97325 4.33398 5.99992C4.33398 7.79992 5.62732 9.29325 7.33398 9.60659V10.9999H6.66732C6.30065 10.9999 6.00065 11.2999 6.00065 11.6666C6.00065 12.0333 6.30065 12.3333 6.66732 12.3333H7.33398V12.9999C7.33398 13.3666 7.63398 13.6666 8.00065 13.6666C8.36732 13.6666 8.66732 13.3666 8.66732 12.9999V12.3333H9.33398C9.70065 12.3333 10.0007 12.0333 10.0007 11.6666C10.0007 11.2999 9.70065 10.9999 9.33398 10.9999H8.66732V9.60659Z" />
  </svg>
);
FemaleIcon.propTypes = { className: PropTypes.string };

export const DividerCircleIcon = ({ className = '' }) => (
  <svg width="3" height="4" viewBox="0 0 3 4" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <circle cx="1.5" cy="2" r="1.5" fill="#BAC0D9" />
  </svg>
);
DividerCircleIcon.propTypes = { className: PropTypes.string };

export const ElectricBolt = ({ className = 'fill-base-front-3' }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M7.34492 1.10496L2.16492 5.74496C1.84492 6.03496 2.02492 6.56996 2.45492 6.60996L6.49992 6.99996L4.07492 10.38C3.96492 10.535 3.97992 10.75 4.11492 10.885C4.26492 11.035 4.49992 11.04 4.65492 10.895L9.83492 6.25496C10.1549 5.96496 9.97492 5.42996 9.54492 5.38996L5.49992 4.99996L7.92492 1.61996C8.03492 1.46496 8.01992 1.24996 7.88492 1.11496C7.73492 0.964964 7.49992 0.959964 7.34492 1.10496Z" />
  </svg>
);
ElectricBolt.propTypes = { className: PropTypes.string };

export const ThumbsUp = ({ className = 'fill-base-front-3' }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M6.47406 1.37593L3.70406 4.14593C3.51906 4.33093 3.41406 4.58593 3.41406 4.85093V9.84593C3.41406 10.3959 3.86406 10.8459 4.41406 10.8459H8.91406C9.31406 10.8459 9.67406 10.6059 9.83406 10.2409L11.4641 6.43593C11.8841 5.44593 11.1591 4.34593 10.0841 4.34593H7.25906L7.73406 2.05593C7.78406 1.80593 7.70906 1.55093 7.52906 1.37093C7.23406 1.08093 6.76406 1.08093 6.47406 1.37593ZM1.41406 10.8459C1.96406 10.8459 2.41406 10.3959 2.41406 9.84593V5.84593C2.41406 5.29593 1.96406 4.84593 1.41406 4.84593C0.864063 4.84593 0.414062 5.29593 0.414062 5.84593V9.84593C0.414062 10.3959 0.864063 10.8459 1.41406 10.8459Z" />
  </svg>

);
ThumbsUp.propTypes = { className: PropTypes.string };

export const Close = ({ className = 'fill-base-front-3' }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M9.20047 0.806647C8.94047 0.546647 8.52047 0.546647 8.26047 0.806647L5.00047 4.05998L1.74047 0.79998C1.48047 0.53998 1.06047 0.53998 0.800469 0.79998C0.540469 1.05998 0.540469 1.47998 0.800469 1.73998L4.06047 4.99998L0.800469 8.25998C0.540469 8.51998 0.540469 8.93998 0.800469 9.19998C1.06047 9.45998 1.48047 9.45998 1.74047 9.19998L5.00047 5.93998L8.26047 9.19998C8.52047 9.45998 8.94047 9.45998 9.20047 9.19998C9.46047 8.93998 9.46047 8.51998 9.20047 8.25998L5.94047 4.99998L9.20047 1.73998C9.4538 1.48665 9.4538 1.05998 9.20047 0.806647Z" fill="#28367B" />
  </svg>
);
Close.propTypes = { className: PropTypes.string };
